import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { Helpers } from "../helpers";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { appService } from "../_services/app.service";
declare var moment: any;
// declare var $: any;
import * as $ from "jquery";
import { forkJoin } from "rxjs/observable/forkJoin";
import { Observable } from 'rxjs';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: "app-print-formats",
  templateUrl: "./print-formats.component.html",
  styleUrls: ["./print-formats.component.scss"],
})
export class PrintFormatsComponent implements OnInit {
  codDodArray: any[] = [];
  totalAmountCodDodArray: any;
  totalAmountInvoiceDetails: any;
  sumInvoiceDetailsAmountAfterCod: any;
  //added by maaria on 22-09-2023
  GSTForKSH: any;
  PANForKSH: any;
  //end
  selectedLang: string;
  hostUrl = environment.apiUrl;
  // hostUrl: any = 'https://ar.ifreightbox.net/';
  // hostUrl = 'https://geetee.ifreightbox.net/';
  // hostUrl = 'https://gatisaar.ifreightbox.net/';
  // hostUrl = 'https://tt.ifreightbox.net/';
  //hostUrl = 'https://infinity.ifreightbox.net/'
  // hostUrl = 'https://oecl.ifreightbox.net/'
  // hostUrl: any ='https://ar.ifreightbox.net/'
  isInternational: boolean = false;
  mgPath: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  SelectedCompanyLUT: any;
  SelectedCompantEmail: any;
  SelectedCompanyPhone: any;
  SelectedCompanyWebsite: any;
  //Added by Burhan - 24/12/25
  SelectedCompanyStamp: any;
  CompanyStamp: any;
  //ended by burhan - 24/12/25
  SelectedCompanyOther: any;
  TenantUsers: any;
  CompanyIdForCookie: any;
  CompanyId: any;
  imgPath: any;
  @Input() InvoiceId: string = "";
  @Input() PrintData: any = [];
  PrintType: any = "";
  InvoiceType: any = "";
  SelectedCompanyLogoImg: any;
  TaxApplicableFlag: boolean = false;
  SumOfAmount: any = 0;
  //added by vithujan 07-03-2023
  PrintGateInPass: any = {};
  static that: PrintFormatsComponent;
  BookingId: any;
  ConsignmentsData: any;
  ConsignmentNoteId: any;
  ConsignmentNote_2 = [1, 2, 3];
  ConsignmentNote_3 = [1, 2, 3, 4];
  CompId: any;
  TermsandConditionsLR: any; //added by BURHAN - 8-July-2026
  From: any;
  SalesFlag: boolean = false;
  //added by vithujan 05-05-2023
  PrintQuoteData: any = [];
  InvoiceData: any = [];
  QuoteCompanyData: any;
  QuoteUserData: any;
  UserId: any;
  //end
  //added by vithujan 03-06-2023
  isISAUrl: any =
    environment.apiUrl == "https://isa.ifreightbox.net/" ? true : false;
  //added by vithujan 22-06-2023
  SelectedCompanyMSME: any;
  svg: any;
  isNCCUrl: any =
    environment.apiUrl == "https://ncc.ifreightbox.net/" ? true : false;
  //added by vithu 18-03-2025
  OnlyHtmlView: boolean = false;
  isDigitalsignin:boolean=false;
  divElements: any;
  hostDomainUrl: any = environment.apiUrl;
  // hostDomainUrl: any = 'https://oecl.ifreightbox.net/';
  isTTUrl: any = environment.apiUrl == 'https://tt.ifreightbox.net/' ? true : false;
  ShipmentModeName: any = '';
  Consignments: any = [];
  CargoModesList: any = [];
  ConsignmentDetailId: any;
  isElavateUrl: any = environment.apiUrl == 'https://escpl.ifreightbox.net/' ? true : false;
  OrderId: any;
  OrderData: any = {};
  SubmissionId: any;
  SelectedBranchName: any;
  SelectedCompanyHeadAddress: any;
  SelectedCompanyHeadPhone: any;
  CompanyBranchNames: any;
  SelectedCompanySAC: any;
  geeteePrintData: any = [];
  hideForDigitalSign = false;
  quoteCompanyEmail = '';
  quoteUserName = '';
  quoteUserEmail = '';
  quoteUserPhone = '';
  companyName = '';
  @Input() PaymentData: any = {};
  SubTotalBillAmount: any;
  SubTotalPaidAmount: any;
  SubTotalAmountDue: any;
  SubTotalPaymentAmount: any;
  SubTotalTDS: any;
  barcodedata: any = [];//Add burhan - 2/1/26
  SaveTablesHeaderColorFlag: boolean = false; //Added by burhan - 2-March-2026
  CompanyPhone: any;//added by burhan - 2-March-2026
  CompanyDescription: any;//added by burhan - 2-March-2026
  @Output() htmlReady = new EventEmitter<string>(); // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
  IsSendMail: boolean = false; // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)

  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private _appService: appService,
    private _activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private cd: ChangeDetectorRef,
     private toaster: ToastrService,
  ) {
    PrintFormatsComponent.that = this;

    if (this.hostUrl == "https://nol.ifreightbox.net/") {
      let language = "en";
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage("en");
        this.selectedLang = "en";
      }
      let val = localStorage.getItem(LNG_KEY);
    } else {
      let language = "en";
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage("en");
        this.selectedLang = "en";
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  ngOnInit() {
    // this.GetSalesFlag();
    // this.LoadTaxApplicable();
    this.SalesFlag = JSON.parse(localStorage.getItem("SalesFlag"));
    this.GetInvoiceLetterHeadSealContainer();

    // Added by Burhan - 24/12/25
    this.CompanyStamp = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyStamp;

    this.SelectedCompanyStamp = environment.apiUrl + this.CompanyStamp;
    // End by Burhan - 24/12/25
  }

  LoadTaxApplicable() {
    var apiUrl =
      environment.apiUrl + "api/Common/GetSystemSettingByName/IsTaxApplicable";

    this.http.get(apiUrl).subscribe(
      (response) => {
        if (response == "1") {
          this.TaxApplicableFlag = true;
        } else {
          this.TaxApplicableFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      }
    );
  }

  PrintInvoice() {
    this.GetSalesFlag();
    this.LoadTaxApplicable();
    this.GetUserCompany(this.InvoiceId);

    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];
      }
    }

    if (this.InvoiceType == "PrintInvoiceKSHSummary") {
      this.GetTaxIdByType(this.PrintData[0].ChargeType);
    }
    if (
      this.InvoiceType != "PrintTripSheet" &&
      this.InvoiceType != "PrintLorryReceipt4" &&
      this.InvoiceType != "PrintLorryReceipt5" &&
      this.InvoiceType != "PrintQuote" &&
      this.InvoiceType != "NewPrintQuote" &&
      this.InvoiceType != "GatisaarLR" &&
      this.InvoiceType != "GeeteeLR" &&
      this.InvoiceType != "IndentLR" &&
      this.InvoiceType != "PrintSubmission" &&
      this.InvoiceType != "PrintPaymentAdvice" &&
      this.InvoiceType != "PrintDetailPaymentAdvice" &&
      this.InvoiceType != "CourierConsignmentNoteLR" &&//added by burhan - 29/12/25
      this.InvoiceType != "CourierLabel"//added by Burhan - 2/1/26
    ) {
      this.PrintData[0].InvoiceDetails.forEach((element) => {
        this.SumOfAmount = this.SumOfAmount + element.kshIAF_Amount;
      });
    }
  }

  //added by maaria on 22-09-2023 by bhavesh sir for ksh print invoice
  GetTaxIdByType(Type: any) {
    this._appService.GetTaxIdByType("Sales", "GetTaxIdByType", Type).subscribe(
      (response) => {
        if (response) {
          this.GSTForKSH = response[0].TaxId;
          this.PANForKSH = this.GSTForKSH.toString().substring(2, 12);
        }
      },
      (err) => {
        this.toastr.error("An error occured while deleting data !", "error");
      }
    );
  }
  //end

  GetSalesFlag() {
    var apiUrl =
      environment.apiUrl + "api/OrdersByVehicle/GetTaxServiceSetting";

    this.http.get(apiUrl).subscribe(
      (res) => {
        const value = JSON.stringify(res);
        this.isInternational = this.getBoolean(value);
      },
      (err) => {
        console.log(err);
      }
    ); // ends here
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  SelectedCompanyMSMENum: any;
  GetUserCompany(id: string) {
    var type = "";
    var singleInvoiceId: any = "";

    if (this.InvoiceType == "PrintTripSheet") {
      singleInvoiceId = this.BookingId;
      type = "BookingId";
    } else if (this.InvoiceType == "PrintLorryReceipt4") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintLorryReceipt5") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintQuote") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "GatisaarLR") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "IndentLR") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintSubmission") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "GeeteeLR") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "NewPrintQuote") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintPaymentAdvice") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintDetailPaymentAdvice") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "CourierConsignmentNoteLR") {//add burhan - 29/12/25
      singleInvoiceId = this.CompId;
      type = "CompanyId"//end by burhan - 29/12/25
    } else if (this.InvoiceType == "CourierLabel") {//add burhan - 2/1/26
      singleInvoiceId = this.CompId;
      type = "CompanyId"//end by burhan - 2/1/26
    } else {
      if (id != null) {
        singleInvoiceId = id.split(",")[0];
      }
      type = "InvoiceId";
    }
    var apiUrl =
      environment.apiUrl +
      "api/Company/GetUserCompanyDataByInvoice?id=" +
      singleInvoiceId +
      "&param1=" +
      type;

    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.TenantUsers = response.data; //FOR DROPDOWN

        this.TenantUsers.forEach((element) => {
          this.CompanyIdForCookie = element;

          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName =
            this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN =
            this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
          this.SelectedCompantEmail =
            this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyPhone =
            this.CompanyIdForCookie.SelectedCompanyPhone;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.SelectedCompanyOther =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg =
            environment.apiUrl + this.SelectedCompanyLogo;
          //added by vithujan 22-06-2023
          this.SelectedCompanyMSME =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          this.SelectedCompanyMSMENum = this.CompanyIdForCookie.SelectedCompanyMSMENum;
          this.SelectedBranchName = this.CompanyIdForCookie.Label;
          this.SelectedCompanyHeadAddress = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
          this.SelectedCompanyHeadPhone = this.CompanyIdForCookie.SelectedCompanyHeadPhone;
          this.CompanyBranchNames = this.CompanyIdForCookie.BranchNames;
          this.SelectedCompanySAC = this.CompanyIdForCookie.SelectedCompanySAC;
        });
        setTimeout(() => {
          
          if (this.InvoiceType == "Summary") {
            setTimeout(() => {
              this.PrintSummary();
            }, 500);
          } else if (this.InvoiceType == "PrintSummary_NCCTransportCharges") {
            this.PrintSummary_NCCTransportCharges();
          } else if (
            this.InvoiceType == "PrintSummary_NCCWithoutTransportCharges"
          ) {
            this.PrintSummary_NCCWithoutTransportCharges();
          } else if (this.InvoiceType == "PrintSummary_NCCBookingWise") {
            this.PrintSummary_NCCBookingWise();
          } else if (this.InvoiceType == "Summary_FixedKM") {
            this.PrintSummary_FixedKM();
          } else if (this.InvoiceType == "Detail") {
            this.PrintDetail();
          } else if (this.InvoiceType == "Detail1") {
            this.PrintDetail1();
          } else if (this.InvoiceType == "PDF_EInvoice") {
            setTimeout(() => {
              this.Print_PDF_EInvoice();
            }, 500);
          } else if (this.InvoiceType == "Detail1OnLatterPad") {
            this.PrintDetail1OnLatterPad();
          } else if (this.InvoiceType == "OnLatterPad_EInvoice") {
            setTimeout(() => {
              this.PrintOnLatterPad_EInvoice();
            }, 500);
          } else if (this.InvoiceType == "Detail_KM_MT") {
            this.PrintDetail_KM_MT();
          } else if (this.InvoiceType == "PrintInvoiceKSH") {
            this.PrintInvoiceKSH();
          } else if (this.InvoiceType == "PrintInvoiceKSHSummary") {
            this.PrintInvoiceKSHSummary();
          } else if (
            this.InvoiceType == "PrintInvoiceAnnexureformatGeneralKSH"
          ) {
            this.PrintInvoiceAnnexureformatGeneral();
          } else if (this.InvoiceType == "PrintTripSheet") {
            this.PrintTripSheet(this.BookingId);
          } else if (this.InvoiceType == "PrintLorryReceipt4") {
            this.PrintLorryReceipt4(this.ConsignmentNoteId);
          } else if (this.InvoiceType == "PrintLorryReceipt5") {
            this.PrintLorryReceipt4(this.ConsignmentNoteId);
          } else if (this.InvoiceType == "NCCTermsCondition") {
            this.PrintNCCTermsCondition();
          } else if (this.InvoiceType == "PrintQuote") {
            this.PrintQuote();
          } else if (this.InvoiceType == "PrintInvoiceInfinity") {
            this.PrintInvoiceInfinity();
          } else if (this.InvoiceType == "GatisaarLR") {
            this.GetCargoModes();
            setTimeout(() => {
              this.PrintGatisaarLR();
            }, 1500);
          } else if (this.InvoiceType == "IndentLR") {
            this.GetIndentLR();
          } else if (this.InvoiceType == "CourierConsignmentNoteLR") {
            this.GetCourierConsignmentNoteLR();
          } else if (this.InvoiceType == "CourierLabel") {
            this.GetCourierLabel();
          }
          else if (this.InvoiceType == "PrintSubmission") {
            this.PrintSubmission();
          } else if (this.InvoiceType == "GeeteeLR") {
            this.PrintGeeteeLR();
          } else if (this.InvoiceType == "Detail1ForDigitalPrint") {
            this.PrintDetail1ForDigitalPrint(); 
          } else if (this.InvoiceType == "PDF_EInvoiceForDigitalSign") {
            this.Print_PDF_EInvoiceForDigitalSign(); 
          } else if (this.InvoiceType == "NewPrintQuote") {
            this.NewPrintQuote();
          } else if (this.InvoiceType == "PrintPaymentAdvice") {
            // Added by priya - 30/12/2025 - print payment advice for payment made 
            this.PrintPaymentAdvice();
          } else if (this.InvoiceType == "PrintDetailPaymentAdvice") {
            // Added by priya - 30/12/2025 - print payment detail advice for payment made 
            //this.PrintDetailPaymentAdvice();
          } else {
            this.PrintUBInvoice();
          }
        }, 1500);
      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  getHtml() {
    if (this.InvoiceType == 'Summary') {
      return this.PrintSummaryDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'PrintSummary_NCCTransportCharges') {
      return this.PrintSummary_NCCTransportChargesDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'PrintInvoiceInfinity') {
      return this.PrintInvoiceInfinityDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Detail') {
      return this.DetailDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Detail1') {
      return this.Detail1Div.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'PDF_EInvoice') {
      return this.PDF_EInvoiceDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Detail1OnLatterPad') {
      return this.Detail1OnLatterPadDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'OnLatterPad_EInvoice') {
      return this.OnLatterPad_EInvoiceDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Summary_FixedKM') {
      return this.Summary_FixedKMDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Detail_KM_MT') {
      return this.Detail_KM_MTDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'PrintInvoiceKSH') {
      return this.PrintInvoiceKSHDiv.nativeElement.innerHTML;
    } else if (this.InvoiceType == 'Detail1ForDigitalPrint') {
      return this.Detail1DivDigitalSign.nativeElement.innerHTML; 
    } else if (this.InvoiceType == 'NewPrintQuote') {
      return this.New_PrintQuoteDiv.nativeElement.innerHTML; 
    } else if (this.InvoiceType == 'PDF_EInvoiceForDigitalSign') {
      return this.Detail2DivDigitalSign.nativeElement.innerHTML; 
    }else {
      return this.AllInOneDiv.nativeElement.innerHTML;
    }
  }

  @ViewChild('PrintSummary') PrintSummaryDiv: ElementRef;
  IsPrintSummary: boolean = false;
  PrintSummary() {
    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetails.sort(function (a, b) {
          var ChargedGSTA = a.ChargedGST ? a.ChargedGST : "";
          var ChargedGSTB = b.ChargedGST ? b.ChargedGST : "";
          return ChargedGSTA.localeCompare(ChargedGSTB);
        });

        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];

        this.PrintData[i].InvoiceDetails.forEach((element) => {
          if (element.ChargedGST == "NA") {
            var isDone: any = false;
            this.PrintData[i].InvoiceDetailsB.forEach((elementD) => {
              if (
                element.ChargeType == elementD.ChargeType &&
                element.SACCODE == elementD.SACCODE &&
                element.ChargedGST == elementD.ChargedGST &&
                element.ToCity == elementD.ToCity &&
                element.Unit == elementD.Unit &&
                element.Rate == elementD.Rate
              ) {
                isDone = true;
                elementD.QuantityA = parseFloat(
                  (elementD.QuantityA + element.Quantity).toFixed(2)
                );
                elementD.DiscountA = parseFloat(
                  (elementD.DiscountA + element.Discount).toFixed(2)
                );
                elementD.AmountA = parseFloat(
                  (elementD.AmountA + element.Amount).toFixed(2)
                );
              }
            });
            if (isDone == false) {
              var objA: any = {};
              objA = element;
              objA.QuantityA = element.Quantity;
              objA.RateA = element.Rate;
              objA.DiscountA = element.Discount;
              objA.AmountA = element.Amount;
              this.PrintData[i].InvoiceDetailsB.push(objA);
            }
          } else {
            var isDone: any = false;
            this.PrintData[i].InvoiceDetailsA.forEach((elementD) => {
              if (
                element.ChargeType == elementD.ChargeType &&
                element.SACCODE == elementD.SACCODE &&
                element.ChargedGST == elementD.ChargedGST &&
                element.ToCity == elementD.ToCity &&
                element.Unit == elementD.Unit &&
                element.Rate == elementD.Rate
              ) {
                isDone = true;
                elementD.QuantityA = parseFloat(
                  (elementD.QuantityA + element.Quantity).toFixed(2)
                );
                elementD.DiscountA = parseFloat(
                  (elementD.DiscountA + element.Discount).toFixed(2)
                );
                elementD.AmountA = parseFloat(
                  (elementD.AmountA + element.Amount).toFixed(2)
                );
              }
            });
            if (isDone == false) {
              var objA: any = {};
              objA = element;
              objA.QuantityA = element.Quantity;
              objA.RateA = element.Rate;
              objA.DiscountA = element.Discount;
              objA.AmountA = element.Amount;
              this.PrintData[i].InvoiceDetailsA.push(objA);
            }
          }

          var data = this.PrintData[i].Charges.filter(
            (x) => x.Name === element.ChargeType
          );
          if (data.length <= 0) {
            var obj: any = {};
            obj.Name = element.ChargeType;
            obj.Amount = 0;
            this.PrintData[i].Charges.push(obj);
          }
        });

        this.PrintData[i].Charges.forEach((element) => {
          var data = this.PrintData[i].InvoiceDetails.filter(
            (x) => x.ChargeType === element.Name
          );
          if (data.length > 0) {
            var totalAmount = 0;
            for (let index = 0; index < data.length; index++) {
              totalAmount = totalAmount + data[index].Amount;
            }
            element.Amount = totalAmount;
          }
        });
      }
    }

    setTimeout(() => {
      // const divElements = document.getElementById("PrintSummary");
      // if (!divElements) return;
      // if (!this.OnlyHtmlView) {
      //   this.IsPrintSummary = true;
      //   const iframe = document.createElement("iframe");
      //   iframe.style.position = "absolute";
      //   iframe.style.width = "0px";
      //   iframe.style.height = "0px";
      //   iframe.style.border = "none";
      //   document.body.appendChild(iframe);

      //   const doc = iframe.contentWindow.document;
      //   doc.open();
      //   doc.write(`
      //         <html>
      //           <head><title>Details</title></head>
      //           <body>${divElements.innerHTML}</body>
      //         </html>
      //       `);
      //   doc.close();

      //   iframe.contentWindow.focus();
      //   iframe.contentWindow.print();

      //   setTimeout(() => {
      //     document.body.removeChild(iframe);
      //     this.IsPrintSummary = false;
      //     this.PrintData = [];
      //   }, 300);
      // }
      var divElements = document.getElementById("PrintSummary");
      this.divElements = divElements.innerHTML;
      console.log(divElements.innerHTML);
      console.log('Inside print compo this.PrintData',this.PrintData);
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true){
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('PrintSummary_NCCTransportCharges') PrintSummary_NCCTransportChargesDiv: ElementRef;
  PrintSummary_NCCTransportCharges() {
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintSummary_NCCTransportCharges"
      );

      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 500);
  }

  PrintSummary_NCCWithoutTransportCharges() {
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintSummary_NCCWithoutTransportCharges"
      );

      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 500);
  }

  PrintSummary_NCCBookingWise() {
    var VarInvoiceDetails: any = [];
    var obj: any = {};
    this.PrintData.forEach((element) => {
      element.TotalQty = 0;
      VarInvoiceDetails = [];
      VarInvoiceDetails = element.InvoiceDetails;
      element.InvoiceDetails = [];
      // var distinctList = VarInvoiceDetails.map(obj => obj.LRNumber).filter((value, index, self) => self.indexOf(value) === index);
      var distinctList = VarInvoiceDetails.map((obj) => ({
        ConsignmentNo: obj.ConsignmentNo,
        PaidWeight: obj.PaidWeight,
      })).filter(
        (value, index, self) =>
          index ===
          self.findIndex((obj) => obj.ConsignmentNo === value.ConsignmentNo)
      );
      var sum_of_gross_wt = 0.0;
      distinctList.forEach((ele) => {
        sum_of_gross_wt += ele.PaidWeight;
      });

      VarInvoiceDetails.forEach((element1) => {
        obj = {};
        obj.FromCity = element1.FromCity;
        obj.ToCity = element1.ToCity;
        obj.PaidWeight = element1.PaidWeight;
        obj.Quantity = element1.Quantity;
        obj.Rate = element1.Rate;
        obj.Discount = element1.Discount;
        obj.Amount = element1.Amount;
        obj.VehicleNo = element.VehicleNo;
        obj.FromToCity = element1.FromToCity;
        //added by vithujan 18-10-2023 - Siddarth
        obj.Route1 = element1.Route1;
        obj.SACCODE = element1.SACCODE;
        obj.LRNumber = element1.LRNumber;

        VarInvoiceDetails.sort(function (a, b) {
          var VehicleNoA = a.LRNumber ? a.LRNumber : "";
          var VehicleNoB = b.LRNumber ? b.LRNumber : "";
          // var VehicleNoA = a.VehicleNo ? a.VehicleNo : '';
          // var VehicleNoB = b.VehicleNo ? b.VehicleNo : '';

          return VehicleNoA.localeCompare(VehicleNoB);
        });

        obj.ChargedGST = element1.ChargedGST;
        let indexToUpdate = element.InvoiceDetails.findIndex(
          (item) =>
            item.FromCity == element1.FromCity && item.ToCity == element1.ToCity
        );
        let indexToUpdatelr = element.InvoiceDetails.findIndex(
          (item) => item.LRNumber == element1.LRNumber
        );
        if (indexToUpdate != -1) {
          element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat(
            sum_of_gross_wt.toFixed(2)
          );
          // if (element1.LRNumber == VarInvoiceDetails[indexToUpdate].LRNumber) {
          //   element.InvoiceDetails[indexToUpdate].PaidWeight = element1.PaidWeight.toFixed(2);
          //   //element1.PaidWeight.toFixed(2);
          // } else {
          //   // if()
          //   element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat(element.InvoiceDetails[indexToUpdate].PaidWeight) + parseFloat(element1.PaidWeight);
          //   //element.InvoiceDetails[indexToUpdate].PaidWeight = element1.PaidWeight.toFixed(2);
          // }

          //element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat((element.InvoiceDetails[indexToUpdate].PaidWeight + element1.PaidWeight).toFixed(2)); works
          // }

          // element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat((element.InvoiceDetails[indexToUpdate].PaidWeight + element1.PaidWeight).toFixed(2));
          // element1.PaidWeight.toFixed(2);

          // element.InvoiceDetails[indexToUpdate].Quantity = parseFloat((element.InvoiceDetails[indexToUpdate].Quantity + element1.Quantity).toFixed(2));
          element.InvoiceDetails[indexToUpdate].Quantity = 1;
          element.InvoiceDetails[indexToUpdate].Rate = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Rate + element1.Rate
            ).toFixed(2)
          );
          element.InvoiceDetails[indexToUpdate].Discount = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Discount + element1.Discount
            ).toFixed(2)
          );
          element.InvoiceDetails[indexToUpdate].Amount = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Amount + element1.Amount
            ).toFixed(2)
          );
        } else {
          element.InvoiceDetails.push(obj);
        }
      });
      element.InvoiceDetails.forEach((element2) => {
        element.TotalQty = parseFloat(
          (element.TotalQty + element2.Quantity).toFixed(2)
        );
      });

      console.log("dd", VarInvoiceDetails);
    });
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummary_NCCBookingWise");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 500);
  }

  @ViewChild('Summary_FixedKM') Summary_FixedKMDiv: ElementRef;
  PrintSummary_FixedKM() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummary_FixedKM");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        Helpers.setLoading(false);

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);

    }, 1000);
  }

  @ViewChild('Detail') DetailDiv: ElementRef;
  PrintDetail() {
    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetails.sort(function (a, b) {
          var ChargedGSTA = a.ChargedGST ? a.ChargedGST : "";
          var ChargedGSTB = b.ChargedGST ? b.ChargedGST : "";
          return ChargedGSTA.localeCompare(ChargedGSTB);
        });

        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];

        this.PrintData[i].InvoiceDetails.forEach((element) => {
          if (element.ChargedGST == "NA") {
            this.PrintData[i].InvoiceDetailsB.push(element);
          } else {
            this.PrintData[i].InvoiceDetailsA.push(element);
          }

          var data = this.PrintData[i].Charges.filter(
            (x) => x.Name === element.ChargeCode
          );
          if (data.length <= 0) {
            var obj: any = {};
            obj.Name = element.ChargeCode;
            obj.Amount = 0;
            this.PrintData[i].Charges.push(obj);
          }
        });

        this.PrintData[i].Charges.forEach((element) => {
          var data = this.PrintData[i].InvoiceDetails.filter(
            (x) => x.ChargeCode === element.Name
          );
          if (data.length > 0) {
            var totalAmount = 0;
            for (let index = 0; index < data.length; index++) {
              totalAmount = totalAmount + data[index].Amount;
            }
            element.Amount = totalAmount;
          }
        });
      }
    }

    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail");
      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

        var printDiv = divElements.innerHTML;

        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();

            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }

      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('Detail1') Detail1Div: ElementRef;
  PrintDetail1() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail1");
      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      console.log("isDigitalsignin", this.isDigitalsignin)
      if (!this.OnlyHtmlView) {

        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv =
          "<style type='text/css' media='print'>@page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        console.log("printDiv", printDiv);
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }
  

  @ViewChild('PDF_EInvoice') PDF_EInvoiceDiv: ElementRef;
  Print_PDF_EInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("Print_PDF_EInvoice");
      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv =
          "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        console.log("printDiv", printDiv);
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('Detail1OnLatterPad') Detail1OnLatterPadDiv: ElementRef;
  PrintDetail1OnLatterPad() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail1_latterPad");
      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

        // <style type='text/css' media='print'>@page { size: auto;  margin: 0mm; }</style>

        var printDiv =
          "<style type='text/css' media='print'>@page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";

        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();

            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }

      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('OnLatterPad_EInvoice') OnLatterPad_EInvoiceDiv: ElementRef;
  PrintOnLatterPad_EInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("Print_latterPad_EInvoice");
      this.divElements = divElements.innerHTML;
      // Added by priya - 13/03/2026 - cn(PRIYA-MAR26-002)
      if (this.IsSendMail == true) {
        this.htmlReady.emit(this.divElements);
      }
      // End by priya
      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        // <style type='text/css' media='print'>@page { size: auto;  margin: 0mm; }</style>
        var printDiv =
          "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('Detail_KM_MT') Detail_KM_MTDiv: ElementRef;
  PrintDetail_KM_MT() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail_KM_MT");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

        var printDiv = divElements.innerHTML;

        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();

            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('AllInOne') AllInOneDiv: ElementRef;
  PrintUBInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintUBInvoice");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

        var printDiv = divElements.innerHTML;

        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();

            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('PrintInvoiceKSH') PrintInvoiceKSHDiv: ElementRef;
  PrintInvoiceKSH() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummaryKSH");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintInvoiceKSHSummary() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummaryKSH_summary");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintInvoiceAnnexureformatGeneral() {
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintInvoiceAnnexureformatGeneralKSH"
      );
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        // var printDiv = divElements.innerHTML;
        var printDiv =
          "<style type='text/css' media='print'>@page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintTripSheet(BookingId) {
    Helpers.setLoading(true);
    PrintFormatsComponent.that._appService
      .GetById("Booking", "GetTripSheet", BookingId)
      .subscribe(
        (response) => {
          PrintFormatsComponent.that.PrintGateInPass = {};
          PrintFormatsComponent.that.PrintGateInPass = response.Table[0];
          PrintFormatsComponent.that.PrintGateInPass.ConsignmentDetailList =
            response.Table1;

          PrintFormatsComponent.that.PrintGateInPass.TotalWeight = 0;
          PrintFormatsComponent.that.PrintGateInPass.TotalQty = 0;
          PrintFormatsComponent.that.PrintGateInPass.TotalAmountValue = 0;

          PrintFormatsComponent.that.PrintGateInPass.ConsignmentDetailList.forEach(
            (element) => {
              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalAmountValue = 0;

              if (
                element.Quantity != null &&
                element.Quantity != "" &&
                element.Quantity != undefined
              )
                TotalQty = element.Quantity;
              else TotalQty = 0;

              if (
                element.GrossWeight != null &&
                element.GrossWeight != "" &&
                element.GrossWeight != undefined
              )
                TotalWeight = element.GrossWeight;
              else TotalWeight = 0;

              if (
                element.InvoiceAmount != null &&
                element.InvoiceAmount !== "" &&
                element.InvoiceAmount !== undefined
              ) {
                const parsedValue = parseFloat(element.InvoiceAmount);
                TotalAmountValue = isNaN(parsedValue) ? 0 : parsedValue;
              }

              PrintFormatsComponent.that.PrintGateInPass.TotalWeight +=
                TotalWeight;
              PrintFormatsComponent.that.PrintGateInPass.TotalQty += TotalQty;
              PrintFormatsComponent.that.PrintGateInPass.TotalAmountValue += TotalAmountValue;
            }
          );

          PrintFormatsComponent.that.PrintGateInPass.TotalWeight = parseFloat(
            PrintFormatsComponent.that.PrintGateInPass.TotalWeight.toFixed(2)
          );

          setTimeout(() => {
            var divElements = document.getElementById("PrintTripSheet");
            var $iframe: any = $("<iframe id='frame'>").appendTo("body");
            var printDiv = divElements.innerHTML;
            console.log('PrintTripSheet.innerHTML:', divElements.innerHTML);
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                }, 500);
              });
            });
            $iframe.contents().find("body").html(printDiv);
            $("#PrintInvoice").val("");
            Helpers.setLoading(false);
          }, 1000);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occured  !", "Error");
        }
      );
  }

  PrintLorryReceipt4(ConsignmentNoteId) {
    console.log("This From :",this.From);
    Helpers.setLoading(true);
    // if (this.hostUrl != 'https://ncc.ifreightbox.net/') {
    PrintFormatsComponent.that._appService
      .GetByTwoId("BookingOrigin", "GetPrintLR4", ConsignmentNoteId, this.From)
      .subscribe(
        (response) => {
          PrintFormatsComponent.that.ConsignmentsData = [];
          PrintFormatsComponent.that.ConsignmentsData.push(
            ...(response as any)
          );
          
          let i = 0;
          //added by BURHAN - 20-Feb-2026
          this.GetSaveTablesHeaderInRed();

          //added by burhan - 19-Feb-2026
          // Company API ko yahan move kiya taaki print se pehle value aa jaye
          this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          this._appService
            .GetById("Company", "GetCompany", this.CompanyId)
            .subscribe(
              (response) => {
                // CompanyDescription set kar diya
                this.CompanyDescription = response.Company.AboutCompany || '';
                this.CompanyPhone = response.AddressDetails.OfficialAddress.Phone || '';
              });
          //end by burhan
          //end by burhan

          setTimeout(() => {
            PrintFormatsComponent.that.ConsignmentsData.forEach((element) => {
              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $(".Consigner_" + i).attr("checked", "true");
              }

              if (
                element.GST == "Consignee" ||
                element.GST == "consigee" ||
                element.GST == "CONSIGEE"
              ) {
                $(".Consignee_" + i).attr("checked", "true");
              }

              if (
                element.GST == "Transporter" ||
                element.GST == "transporter" ||
                element.GST == "TRANSPORTER"
              ) {
                $(".Transporter_" + i).attr("checked", "true");
              }

              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalValue = 0;
              element.ProductDetail.forEach((element) => {
                TotalQty = TotalQty + element.Quantity;
                TotalWeight = TotalWeight + element.GrossWeight;
                TotalValue = TotalValue + element.Value;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            });
          }, 200);

          if (this.InvoiceType == "PrintLorryReceipt4") {
            setTimeout(() => {
              this.printContent('PrintLorryReceipt4','Lorry Receipt')
              // var divElements = document.getElementById("PrintLorryReceipt4");
              // var $iframe: any = $("<iframe id='frame'>").appendTo("body");
              // var printDiv = divElements.innerHTML;
              // var win = $iframe[0].contentWindow || $iframe[0];
              // $(win.document).ready(function () {
              //   setTimeout(() => {
              //     win.window.print();
              //     setTimeout(() => {
              //       $iframe.remove();
              //     }, 500);
              //   });
              // });
              // $iframe.contents().find("body").html(printDiv);
              // $("#PrintInvoice").val("");
              // Helpers.setLoading(false);
            }, 1000);
          }
          if (this.InvoiceType == "PrintLorryReceipt5") {
            this.printContent('ModalConsignmentNote_LR5', 'Lorry Receipt')
            setTimeout(() => {
              // var divElements = document.getElementById("PrintLorryReceipt5");
              // var $iframe: any = $("<iframe id='frame'>").appendTo("body");
              // var printDiv = divElements.innerHTML;
              // var win = $iframe[0].contentWindow || $iframe[0];
              // $(win.document).ready(function () {
              //   setTimeout(() => {
              //     win.window.print();
              //     setTimeout(() => {
              //       $iframe.remove();
              //     }, 500);
              //   });
              // });
              // $iframe.contents().find("body").html(printDiv);
              // $("#PrintInvoice").val("");
              // Helpers.setLoading(false);
            }, 800);
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occured  !", "Error");
        }
      );
    // } else {
    //   PrintFormatsComponent.that._appService.GetById("OrdersByVehicle", "GetPrintLR4Indent", ConsignmentNoteId).subscribe((response) => {
    //     PrintFormatsComponent.that.ConsignmentsData = [];
    //     PrintFormatsComponent.that.ConsignmentsData.push(...response as any);
    //     let i = 0;
    //     console.log('PrintFormatsComponent.that.ConsignmentsData', PrintFormatsComponent.that.ConsignmentsData);

    //     setTimeout(() => {
    //       PrintFormatsComponent.that.ConsignmentsData.forEach(
    //         (element) => {

    //           if (
    //             element.GST == "Consignor" ||
    //             element.GST == "consignor" ||
    //             element.GST == "CONSIGNOR"
    //           ) {
    //             $(".Consigner_" + i).attr("checked", 'true');
    //           }

    //           if (
    //             element.GST == "Consignee" ||
    //             element.GST == "consigee" ||
    //             element.GST == "CONSIGEE"
    //           ) {
    //             $(".Consignee_" + i).attr("checked", 'true');
    //           }

    //           if (
    //             element.GST == "Transporter" ||
    //             element.GST == "transporter" ||
    //             element.GST == "TRANSPORTER"
    //           ) {
    //             $(".Transporter_" + i).attr("checked", 'true');
    //           }

    //           var TotalQty = 0;
    //           var TotalWeight = 0;
    //           var TotalValue = 0;
    //           element.ProductDetail.forEach((element) => {
    //             TotalQty = TotalQty + element.Quantity;
    //             TotalWeight = TotalWeight + element.GrossWeight;
    //             TotalValue = TotalValue + element.Value;
    //           });

    //           element.TotalQty = TotalQty;
    //           element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
    //           element.TotalValue = TotalValue;
    //           i++;
    //         }
    //       );
    //     }, 200);

    //     setTimeout(() => {
    //       var divElements = document.getElementById("PrintLRIndent");
    //       var $iframe: any = $("<iframe id='frame'>").appendTo("body");
    //       var printDiv = divElements.innerHTML;
    //       var win = $iframe[0].contentWindow || $iframe[0];
    //       $(win.document).ready(function () {
    //         setTimeout(() => {
    //           win.window.print();
    //           setTimeout(() => {
    //             $iframe.remove();
    //           }, 500);
    //         });
    //       });
    //       $iframe.contents().find("body").html(printDiv);
    //       $("#PrintInvoice").val("");
    //       Helpers.setLoading(false);
    //     }, 1000);
    //   },
    //     (err) => {
    //       Helpers.setLoading(false);
    //       this.toastr.error("An error occured  !", "Error");
    //     });
    // }
  }

  //added by Burhan - 3-March-2026
  // PrintLorryReceipt5(ConsignmentNoteId){
  //   PrintFormatsComponent.that._appService
  //     .GetByTwoId("BookingOrigin", "GetPrintLR4", ConsignmentNoteId, this.From)
  //     .subscribe(
  //       (response) => {
  //         PrintFormatsComponent.that.ConsignmentsData = [];
  //         PrintFormatsComponent.that.ConsignmentsData.push(
  //           ...(response as any)
  //         );
  //         let i = 0;

  //         setTimeout(() => {
  //           PrintFormatsComponent.that.ConsignmentsData.forEach((element) => {
  //             if (
  //               element.GST == "Consignor" ||
  //               element.GST == "consignor" ||
  //               element.GST == "CONSIGNOR"
  //             ) {
  //               $(".Consigner_" + i).attr("checked", "true");
  //             }

  //             if (
  //               element.GST == "Consignee" ||
  //               element.GST == "consigee" ||
  //               element.GST == "CONSIGEE"
  //             ) {
  //               $(".Consignee_" + i).attr("checked", "true");
  //             }

  //             if (
  //               element.GST == "Transporter" ||
  //               element.GST == "transporter" ||
  //               element.GST == "TRANSPORTER"
  //             ) {
  //               $(".Transporter_" + i).attr("checked", "true");
  //             }

  //             var TotalQty = 0;
  //             var TotalWeight = 0;
  //             var TotalValue = 0;
  //             element.ProductDetail.forEach((element) => {
  //               TotalQty = TotalQty + element.Quantity;
  //               TotalWeight = TotalWeight + element.GrossWeight;
  //               TotalValue = TotalValue + element.Value;
  //             });

  //             element.TotalQty = TotalQty;
  //             element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
  //             element.TotalValue = TotalValue;
  //             i++;
  //           });
  //         }, 200);
          
  //         if (this.InvoiceType == "PrintLorryReceipt5") {
  //           setTimeout(() => {
  //             this.printContent('ModalConsignmentNote_LR5', 'Lorry Receipt')
  //             // var divElements = document.getElementById("PrintLorryReceipt5");
  //             // var $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //             // var printDiv = divElements.innerHTML;
  //             // var win = $iframe[0].contentWindow || $iframe[0];
  //             // $(win.document).ready(function () {
  //             //   setTimeout(() => {
  //             //     win.window.print();
  //             //     setTimeout(() => {
  //             //       $iframe.remove();
  //             //     }, 500);
  //             //   });
  //             // });
  //             // $iframe.contents().find("body").html(printDiv);
  //             // $("#PrintInvoice").val("");
  //             // Helpers.setLoading(false);
  //           }, 1000);
  //         }
  //       },
  //       (err) => {
  //         Helpers.setLoading(false);
  //         this.toastr.error("An error occured  !", "Error");
  //       }
  //     );
  // }
  //end by BURHAN - 3-March-2026
  //added by vithujan 08-04-2023
  PrintNCCTermsCondition() {
    setTimeout(() => {
      var divElements = document.getElementById("ModalTermsCondition");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  //added by vithujan 05-05-2023
  TotalAmount: any = 0;
  TotalAdvance: any = 0;
  TotalBalance: any = 0;
  PrintQuote() {
    this.TotalAmount = 0;
    this.TotalAdvance = 0;
    this.TotalBalance = 0;

    let i = 0;
    this.InvoiceData = [];
    this.QuoteCompanyData = {};
    this.QuoteUserData = {};

    this._appService
      .GetById(
        "byVehicleIncome",
        "GetChargeListByIndentId",
        this.PrintQuoteData[0].Id
      )
      .subscribe(
        (res) => {
          res.forEach((element) => {
            this.InvoiceData.push(element);
            this.TotalAmount = this.TotalAmount + element.Amount;
            this.TotalAdvance = this.TotalAdvance + element.Advance;
            this.TotalBalance = this.TotalAmount - this.TotalAdvance;
          });

          this._appService
            .GetById("OrdersByVehicle", "GetCompanyForQuote", this.UserId)
            .subscribe(
              (res) => {
                this.QuoteCompanyData = res.Table[0];
                this.QuoteUserData = res.Table1[0];

                setTimeout(() => {
                  // kevin 13/03/2020
                  var divElements = document.getElementById("ModalPrintQuote");
                  // var $iframe = $("<iframe id='frame'>").appendTo("body");
                  var printDiv =
                    "<html><head><title> Lorry Receipt </title></head><body>" +
                    divElements.innerHTML +
                    "</body></html>";

                  var $iframe: any = $("<iframe id='frame'>").appendTo("body");
                  var printDiv = divElements.innerHTML;
                  var win = $iframe[0].contentWindow || $iframe[0];
                  $(win.document).ready(function () {
                    setTimeout(() => {
                      win.window.print();
                      setTimeout(() => {
                        $iframe.remove();
                      }, 100);
                    });
                  });
                  $iframe.contents().find("body").html(printDiv);
                }, 200);
              },
              (err) => {
                this.toastr.error("An error occured  !", "Error");
              }
            );
        },
        (err) => {
          this.toastr.error("An error occured  !", "Error");
        }
      );
  }
  //end

  @ViewChild('PrintInvoiceInfinity') PrintInvoiceInfinityDiv: ElementRef;
  PrintInvoiceInfinity() {
    this.totalAmountInvoiceDetails = 0;
    this.totalAmountCodDodArray = 0;

    for (var i = 0; i < this.PrintData.length; i++) {
      this.PrintData[i].InvoiceDetailsA = [];
      this.PrintData[i].InvoiceDetailsB = [];
      this.PrintData[i].Charges = [];
      this.codDodArray = [];

      this.PrintData[i].InvoiceDetails.forEach((element) => {
        if (element.ChargedGST == "NA") {
          this.PrintData[i].InvoiceDetailsB.push(element);
        } else {
          this.PrintData[i].InvoiceDetailsA.push(element);
        }

        var data = this.PrintData[i].Charges.filter(
          (x) => x.Name === element.ChargeCode
        );
        if (data.length <= 0) {
          var obj: any = {};
          obj.Name = element.ChargeCode;
          obj.Amount = 0;
          this.PrintData[i].Charges.push(obj);
        }

        this.totalAmountInvoiceDetails += element.Amount;
        if (element.IsCod_dod === 1) {
          this.codDodArray.push(element);
          this.totalAmountCodDodArray += element.Amount;
        }
      });

      this.sumInvoiceDetailsAmountAfterCod = this.PrintData[
        i
      ].InvoiceDetails.reduce((total, element) => total + element.Amount, 0);
      console.log(
        this.sumInvoiceDetailsAmountAfterCod,
        "Total sum of InvoiceDetails amounts after pushing into codDodArray"
      );

      this.PrintData[i].InvoiceDetails = this.PrintData[
        i
      ].InvoiceDetails.filter((element) => element.IsCod_dod !== 1);

      console.log(
        this.totalAmountInvoiceDetails,
        "Total amount of InvoiceDetails"
      );
      console.log(this.totalAmountCodDodArray, "Total amount of codDodArray");
      console.log(this.codDodArray, "codarray");
    }
    setTimeout(() => {
      var divElements = document.getElementById("PrintInvoiceInfinity");
      this.divElements = divElements.innerHTML;

      if (!this.OnlyHtmlView) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

        var printDiv =
          "<style type='text/css' media='print'>@page { size: landscape; }</style><html><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";

        var win = $iframe[0].contentWindow || $iframe[0];

        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();

            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });

        $iframe.contents().find("body").html(printDiv);

        $("#PrintInvoice").val("");
      }

      Helpers.setLoading(false);
    }, 1000);
  }

  // added by vithu 21-07-2025
  PrintGatisaarLR() {
    Helpers.setLoading(true);

    this._appService
      .GetById("BookingOrigin", "getConsignmentDetailList", this.ConsignmentNoteId)
      .subscribe(
        (response) => {
          this.Consignments = [];

          if (response) {
            this.Consignments.push(...(response as any));
          }

          if (this.Consignments.length > 0) {
            this.Consignments[0].ShipmentModeName = this.ShipmentModeName;
          }

          let i = 0;

          this._appService
            .GetByTwoId("Booking", "GetDataForLRPrint", this.BookingId, this.CompanyId)
            .subscribe(
              (res) => {
                Helpers.setLoading(false);

                if (res && res.length > 0 && this.Consignments.length > 0) {
                  const data = res[0];
                  const consignment = this.Consignments[0];

                  consignment.DriverName = data.DriverName;
                  consignment.VehicleType = data.VehicleType;
                  consignment.transporterAddress = data.transporterAddress;
                  consignment.LicenseNo = data.LicenseNo;
                  consignment.TransportName = data.TransportName;
                  consignment.eWayBillNo = data.eWayBillNo;
                  consignment.eWayBillExpiryDate = data.eWayBillExpiryDate;
                  consignment.containerNo = data.containerNo;
                  consignment.sealNo = data.sealNo;
                  consignment.DINo = data.DINo;
                  consignment.companyHeadAddress = data.companyHeadAddress;
                }

                setTimeout(() => {
                  this.Consignments.forEach((element) => {
                    // const risk = (element.Risk || "").toLowerCase();
                    // const freight = (element.Freight || "").replace(/\s+/g, "").toLowerCase();
                    // const gst = (element.GST || "").toLowerCase();

                    // if (risk === "owner") {
                    //   $("#chkOwn_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkTransporter_" + i).prop("checked", true);
                    // }

                    // if (["topay"].includes(freight)) {
                    //   $("#chkToPay_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkToBill_" + i).prop("checked", true);
                    // }

                    // if (gst === "consignor") {
                    //   $("#chkConsignor_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkGSTTransporter_" + i).prop("checked", true);
                    // }

                    // if (element.Insured) {
                    //   $("#chkInsureYes_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkInsureNo_" + i).prop("checked", true);
                    // }

                    let TotalQty = 0;
                    let TotalWeight = 0;
                    let TotalValue = 0;

                    (element.ProductDetail || []).forEach((p) => {
                      TotalQty += p.Quantity || 0;
                      TotalWeight += p.GrossWeight || 0;
                      TotalValue += p.Value || 0;
                    });

                    element.TotalQty = TotalQty;
                    element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                    element.TotalValue = TotalValue;

                    i++;
                  });

                  if (this.Consignments.length > 0) {
                    // Cargo Mode
                    const cargoMode = (PrintFormatsComponent.that.Consignments[0].CargoMode || "").toLowerCase();
                    this.CargoModesList.forEach(element => {
                      const label = element.Label || "";
                      const classSelector = `.chk_${label}`;

                      if (label.toLowerCase() === cargoMode) {
                        $(classSelector).attr("checked", "checked");
                      } else {
                        $(classSelector).removeAttr("checked");
                      }
                    });

                    // Payment Modes
                    const freight = (PrintFormatsComponent.that.Consignments[0].Freight || "").replace(/\s+/g, "").toLowerCase();
                    if (freight === "topay") {
                      $(".chkPaymentModeToPay").attr("checked", "checked");
                    } else {
                      $(".chkPaymentModeToPay").removeAttr("checked");
                    }

                    if (freight === "tobill") {
                      $(".chkPaymentModeToBilled").attr("checked", "checked");
                      PrintFormatsComponent.that.Consignments[0].Advance = 0;
                      PrintFormatsComponent.that.Consignments[0].FreightCharges = 0;
                      PrintFormatsComponent.that.Consignments[0].FOVCharges = 0;
                      PrintFormatsComponent.that.Consignments[0].StationeryCharges = 0;
                      PrintFormatsComponent.that.Consignments[0].CODCharges = 0;
                      PrintFormatsComponent.that.Consignments[0].TotalCharges = 0;
                    } else {
                      $(".chkPaymentModeToBilled").removeAttr("checked");
                    }
                    // $(".chkPaymentModeToPaid").prop("checked", freight === "topaid")

                    const risk = (PrintFormatsComponent.that.Consignments[0].Risk || "").toLowerCase();
                    // For Owner checkbox
                    if (risk === "owner") {
                      $(".chkOwnerRisk").attr("checked", "checked");
                    } else {
                      $(".chkOwnerRisk").removeAttr("checked");
                    }

                    // For Transporter checkbox
                    if (risk === "transporter") {
                      $(".chkTransporterRisk").attr("checked", "checked");
                    } else {
                      $(".chkTransporterRisk").removeAttr("checked");
                    }

                    // $(".chkOwnerRisk").each(function () {
                    //   const cargoMode = PrintFormatsComponent.that.Consignments[0].Risk;
                    //   if (cargoMode && cargoMode.toLowerCase() === "owner") {
                    //     $(this).attr("checked", "true");
                    //   } else {
                    //     $(this).attr("checked", "false");
                    //   }
                    // });
                  }
                }, 1000);

                // Print Section
                setTimeout(() => {
                  const divElements = document.getElementById("PrintGatisaarLR");

                  if (divElements) {
                    const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                    const printDiv = divElements.innerHTML;
                    const win = $iframe[0].contentWindow || $iframe[0];

                    $(win.document).ready(() => {
                      setTimeout(() => {
                        win.window.print();
                        setTimeout(() => {
                          $iframe.remove();
                        }, 500);
                      });
                    });

                    $iframe.contents().find("body").html(printDiv);
                  }

                  $("#PrintInvoice").val("");
                  Helpers.setLoading(false);
                }, 1000);
              },
              (err) => {
                Helpers.setLoading(false);
                this.toastr.error(err._body.replace(/"/g, "") || "Unknown error", "Error");
              }
            );
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occurred while fetching consignment data!", "Error");
        }
      );
  }

  GetCargoModes() {
    setTimeout(() => {
      this._appService
        .Get("OrdersByVehicle", "GetCargoModes")
        .subscribe(
          (response) => {

            this.CargoModesList = response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching cargo modes data !",
              "error"
            );
          }
        );
    }, 200);
  }

  PrintArray: any = [];
  containerNo: any;
  sealNo: any;
  GetIndentLR() {
    if (this.hostUrl != 'https://ncc.ifreightbox.net/') {
      if (this.hostUrl != 'https://ksh.ifreightbox.net/' && this.isElavateUrl != true) {
        this.PrintArray = [];//Add by burhan - 29/12/25
        this.PrintArray.push(this.OrderData);
        let i = 0;
        setTimeout(() => {
          this.PrintArray.forEach(
            (element) => {
              if (
                element.Risk == "Owner" ||
                element.Risk == "owner" ||
                element.Risk == "OWNER"
              ) {
                $(".chkOwn_" + i).attr("checked", "checked");
              } else {
                $(".chkTransporter_" + i).attr("checked", "checked");
              }

              if (
                element.Freight == "To Pay" ||
                element.Freight == "to pay" ||
                element.Freight == "To pay" ||
                element.Freight == "TO PAY" ||
                element.Freight == "ToPay"
              ) {
                $(".chkToPay_" + i).attr("checked", "checked");
              } else {
                $(".chkToBill_" + i).attr("checked", "checked");
              }

              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $(".chkConsignor_" + i).attr("checked", "checked");
              } else {
                $(".chkGSTTransporter_" + i).attr("checked", "checked");
              }

              if (element.Insured) {
                $(".chkInsureYes_" + i).attr("checked", "checked");
              } else {
                $(".chkInsureNo_" + i).attr("checked", "checked");
              }

              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalValue = 0;
              element.ProductList.forEach((element) => {
                TotalQty = TotalQty + element.Qty;
                TotalWeight = TotalWeight + element.weight;
                TotalValue = TotalValue + element.InvoiceAmount;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            }
          );
        }, 200);

        // Print Section
        setTimeout(() => {
          this.cd.detectChanges();
          var divElements = document.getElementById("ModalConsignmentNote2_New");
          if (this.hostUrl == 'https://ksh.ifreightbox.net/') {
            divElements = document.getElementById("ModalConsignmentNote_3_New");
          }
          if (divElements) {
            const $iframe: any = $("<iframe id='frame'>").appendTo("body");            
              var printDiv = divElements.innerHTML;
            console.log('divelement', divElements);
            console.log('printarr', this.PrintArray);
            const win = $iframe[0].contentWindow || $iframe[0];

            $(win.document).ready(() => {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                }, 500);
              });
            });

            $iframe.contents().find("body").html(printDiv);
          }

          $("#PrintInvoice").val("");
          Helpers.setLoading(false);
        }, 1000);
      } else {
        this._appService
          .GetById(
            "OrdersByVehicle",
            "GetPrintLR4Indent",
            this.OrderId
          )
          .subscribe(
            (response) => {
              this.ConsignmentsData =
                [];
              this.ConsignmentsData.push(
                ...(response as any)
              );

              let i = 0;
              this._appService
                .GetById("Booking", "GetDataForLRPrintKSH", this.OrderId)
                .subscribe(
                  (response) => {
                    Helpers.setLoading(false);

                    if (response.length > 0) {
                      this.ConsignmentsData[0].DriverName =
                        response[0].DriverName;
                      this.ConsignmentsData[0].VehicleType =
                        response[0].VehicleType;
                      this.ConsignmentsData[0].transporterAddress =
                        response[0].transporterAddress;
                      this.ConsignmentsData[0].LicenseNo =
                        response[0].LicenseNo;
                      this.ConsignmentsData[0].TransportName =
                        response[0].TransportName;
                      this.ConsignmentsData[0].eWayBillNo =
                        response[0].eWayBillNo;
                      this.ConsignmentsData[0].eWayBillExpiryDate =
                        response[0].eWayBillExpiryDate;
                      this.ConsignmentsData[0].containerNo =
                        response[0].containerNo;

                      //add trupti 01-nov-2021
                      if (
                        this.ConsignmentsData[0]
                          .ReferenceNo != null
                      ) {
                        let printSealNo =
                          this.ConsignmentsData[0].ReferenceNo.split(
                            "/"
                          );
                        this.containerNo =
                          printSealNo[0];
                        this.containerNo = printSealNo[0];
                        if (printSealNo[1]) {
                          this.sealNo =
                            printSealNo[1].split(":")[1];
                          this.sealNo = printSealNo[1].split(":")[1];
                        }
                      }
                      //end
                    }

                    setTimeout(() => {
                      this.ConsignmentsData.forEach(
                        (element) => {
                          if (
                            element.Risk == "Owner" ||
                            element.Risk == "owner" ||
                            element.Risk == "OWNER"
                          ) {
                            $(".chkOwn_" + i).attr("checked", "checked");
                          } else {
                            $(".chkTransporter_" + i).attr(
                              "checked",
                              "checked"
                            );
                          }

                          if (
                            element.Freight == "To Pay" ||
                            element.Freight == "to pay" ||
                            element.Freight == "To pay" ||
                            element.Freight == "TO PAY" ||
                            element.Freight == "ToPay"
                          ) {
                            $(".chkToPay_" + i).attr("checked", "checked");
                          } else {
                            $(".chkToBill_" + i).attr("checked", "checked");
                          }

                          if (
                            element.GST == "Consignor" ||
                            element.GST == "consignor" ||
                            element.GST == "CONSIGNOR"
                          ) {
                            $(".chkConsignor_" + i).attr("checked", "checked");
                          } else {
                            $(".chkGSTTransporter_" + i).attr(
                              "checked",
                              "checked"
                            );
                          }

                          if (element.Insured) {
                            $(".chkInsureYes_" + i).attr("checked", "checked");
                          } else {
                            $(".chkInsureNo_" + i).attr("checked", "checked");
                          }

                          var TotalQty = 0;
                          var TotalWeight = 0;
                          var TotalValue = 0;
                          var BoxPerPallet = 0;
                          element.ProductDetail.forEach((element) => {
                            TotalQty = TotalQty + element.Quantity;
                            TotalWeight = TotalWeight + element.GrossWeight;
                            TotalValue = TotalValue + element.Value;
                            BoxPerPallet = BoxPerPallet + element.BoxPerPallet;
                          });

                          element.TotalQty = TotalQty;
                          element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                          element.TotalValue = TotalValue;
                          element.TotalBoxPerPallet = BoxPerPallet;
                          i++;
                        }
                      );
                    }, 200);

                    // Print Section
                    setTimeout(() => {
                      const divElements = document.getElementById("ModalConsignmentNote_3_KSH_New");

                      if (divElements) {
                        const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                        const printDiv = divElements.innerHTML;
                        const win = $iframe[0].contentWindow || $iframe[0];

                        $(win.document).ready(() => {
                          setTimeout(() => {
                            win.window.print();
                            setTimeout(() => {
                              $iframe.remove();
                            }, 500);
                          });
                        });

                        $iframe.contents().find("body").html(printDiv);
                      }

                      $("#PrintInvoice").val("");
                      Helpers.setLoading(false);
                    }, 1000);
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(
                      err._body.replace(/"/g, ""),
                      "error"
                    );
                  }
                );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured  !", "Error");
            }
          );
      }
    } else {
      this.InvoiceType = "PrintLorryReceipt4";
      this.From = "Origin";
      this.ConsignmentNoteId = this.OrderId;
      this.CompId = this.CompanyId;
      $("#PrintInvoice").val("");
      this.PrintInvoice();
    }
  }

  //add burhan - 29/12/25
  GetCourierConsignmentNoteLR(){
    Helpers.setLoading(true);
    if (this.hostUrl != 'https://ncc.ifreightbox.net/') {
      if (this.hostUrl != 'https://ksh.ifreightbox.net/' && this.isElavateUrl != true) {
        this.PrintArray = [];
        this.PrintArray.push(this.OrderData);
        console.log("Order Data :",this.PrintArray);
        console.log("Logo :", this.imgPath);
        let i = 0;
        setTimeout(() => {
          this.PrintArray.forEach(
            (element) => {
              if (
                element.Risk == "Owner" ||
                element.Risk == "owner" ||
                element.Risk == "OWNER"
              ) {
                $(".chkOwn_" + i).attr("checked", "checked");
              } else {
                $(".chkTransporter_" + i).attr("checked", "checked");
              }

              if (
                element.Freight == "To Pay" ||
                element.Freight == "to pay" ||
                element.Freight == "To pay" ||
                element.Freight == "TO PAY" ||
                element.Freight == "ToPay"
              ) {
                $(".chkToPay_" + i).attr("checked", "checked");
              } else {
                $(".chkToBill_" + i).attr("checked", "checked");
              }

              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $(".chkConsignor_" + i).attr("checked", "checked");
              } else {
                $(".chkGSTTransporter_" + i).attr("checked", "checked");
              }

              if (element.Insured) {
                $(".chkInsureYes_" + i).attr("checked", "checked");
              } else {
                $(".chkInsureNo_" + i).attr("checked", "checked");
              }

              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalValue = 0;
              element.ProductList.forEach((element) => {
                TotalQty = TotalQty + element.Qty;
                TotalWeight = TotalWeight + element.weight;
                TotalValue = TotalValue + element.InvoiceAmount;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            }
          );
        }, 200);

        // Print Section
        setTimeout(() => {
          this.cd.detectChanges();
          var divElements = document.getElementById("ModalConsignmentNote_4_New");
          // if (this.hostUrl == 'https://ksh.ifreightbox.net/') {
          //   divElements = document.getElementById("ModalConsignmentNote_3_New");
          // }
          if (divElements) {
            const $iframe: any = $("<iframe style='position:absolute;top:-10000px;'>").appendTo("body");
            const win = $iframe[0].contentWindow;

            const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-app-color').trim() || '#000';

            const printdev = `
                <!DOCTYPE html>
                <html>
                <head>
                  <title>Courier Consignment Note</title>

                  <style type='text/css' media='print'>
                    @page { size: landscape; }

                    .print-primary-bg {
                      background-color: ${primaryColor} !important;
                      color: #fff !important;
                      font-weight: bold;
                      text-align: center;
                    }
                  </style>
                </head>

                <body>
                  ${divElements.innerHTML}
                </body>
                </html>
              `;
            // var printdev =
            //   "<style type='text/css' media='print'>@page { size: landscape; }</style><html><head><link rel='stylesheet' href='./src/assets/demo/default/base/style.bundle.css'><title> Indent LR </title></head><body>" +
            //   divElements.innerHTML +
            //   "</body></html>";

            // const printdev = `
            // <html>
            //   <head>
            //     <title>Indent LR</title>
            //       <style>
            //         @page { size: landscape; }

            //         .print-primary-bg {
            //         background-color: var(--primary-app-color) !important;
            //         color: #ffffff !important;
            //         -webkit-print-color-adjust: exact !important;
            //         print-color-adjust: exact !important;
            //       }
            //       </style>
            //     </head>
            //   <body>
            //     ${divElements.innerHTML}
            //   </body>
            // </html>
            // `;
            win.document.open();
            win.document.write(printdev);
            win.document.close();

            //wait AFTER content is written
            setTimeout(() => {
              win.focus();
              win.print();

              setTimeout(() => {
                $iframe.remove();
                Helpers.setLoading(false);
              }, 500);
            }, 500);
          }


          $("#PrintInvoice").val("");
        }, 1000);
      } else {
        this._appService
          .GetById(
            "OrdersByVehicle",
            "GetPrintLR4Indent",
            this.OrderId
          )
          .subscribe(
            (response) => {
              this.ConsignmentsData =
                [];
              this.ConsignmentsData.push(
                ...(response as any)
              );

              let i = 0;
              this._appService
                .GetById("Booking", "GetDataForLRPrintKSH", this.OrderId)
                .subscribe(
                  (response) => {
                    Helpers.setLoading(false);

                    if (response.length > 0) {
                      this.ConsignmentsData[0].DriverName =
                        response[0].DriverName;
                      this.ConsignmentsData[0].VehicleType =
                        response[0].VehicleType;
                      this.ConsignmentsData[0].transporterAddress =
                        response[0].transporterAddress;
                      this.ConsignmentsData[0].LicenseNo =
                        response[0].LicenseNo;
                      this.ConsignmentsData[0].TransportName =
                        response[0].TransportName;
                      this.ConsignmentsData[0].eWayBillNo =
                        response[0].eWayBillNo;
                      this.ConsignmentsData[0].eWayBillExpiryDate =
                        response[0].eWayBillExpiryDate;
                      this.ConsignmentsData[0].containerNo =
                        response[0].containerNo;

                      //add trupti 01-nov-2021
                      if (
                        this.ConsignmentsData[0]
                          .ReferenceNo != null
                      ) {
                        let printSealNo =
                          this.ConsignmentsData[0].ReferenceNo.split(
                            "/"
                          );
                        this.containerNo =
                          printSealNo[0];
                        this.containerNo = printSealNo[0];
                        if (printSealNo[1]) {
                          this.sealNo =
                            printSealNo[1].split(":")[1];
                          this.sealNo = printSealNo[1].split(":")[1];
                        }
                      }
                      //end
                    }

                    setTimeout(() => {
                      this.ConsignmentsData.forEach(
                        (element) => {
                          if (
                            element.Risk == "Owner" ||
                            element.Risk == "owner" ||
                            element.Risk == "OWNER"
                          ) {
                            $(".chkOwn_" + i).attr("checked", "checked");
                          } else {
                            $(".chkTransporter_" + i).attr(
                              "checked",
                              "checked"
                            );
                          }

                          if (
                            element.Freight == "To Pay" ||
                            element.Freight == "to pay" ||
                            element.Freight == "To pay" ||
                            element.Freight == "TO PAY" ||
                            element.Freight == "ToPay"
                          ) {
                            $(".chkToPay_" + i).attr("checked", "checked");
                          } else {
                            $(".chkToBill_" + i).attr("checked", "checked");
                          }

                          if (
                            element.GST == "Consignor" ||
                            element.GST == "consignor" ||
                            element.GST == "CONSIGNOR"
                          ) {
                            $(".chkConsignor_" + i).attr("checked", "checked");
                          } else {
                            $(".chkGSTTransporter_" + i).attr(
                              "checked",
                              "checked"
                            );
                          }

                          if (element.Insured) {
                            $(".chkInsureYes_" + i).attr("checked", "checked");
                          } else {
                            $(".chkInsureNo_" + i).attr("checked", "checked");
                          }

                          var TotalQty = 0;
                          var TotalWeight = 0;
                          var TotalValue = 0;
                          var BoxPerPallet = 0;
                          element.ProductDetail.forEach((element) => {
                            TotalQty = TotalQty + element.Quantity;
                            TotalWeight = TotalWeight + element.GrossWeight;
                            TotalValue = TotalValue + element.Value;
                            BoxPerPallet = BoxPerPallet + element.BoxPerPallet;
                          });

                          element.TotalQty = TotalQty;
                          element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                          element.TotalValue = TotalValue;
                          element.TotalBoxPerPallet = BoxPerPallet;
                          i++;
                        }
                      );
                    }, 200);

                    // Print Section
                    setTimeout(() => {
                      const divElements = document.getElementById("ModalConsignmentNote_3_KSH_New");

                      if (divElements) {
                        const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                        const printDiv = divElements.innerHTML;
                        const win = $iframe[0].contentWindow || $iframe[0];

                        $(win.document).ready(() => {
                          setTimeout(() => {
                            win.window.print();
                            setTimeout(() => {
                              $iframe.remove();
                              Helpers.setLoading(false);
                            }, 500);
                          });
                        });

                        $iframe.contents().find("body").html(printDiv);
                      }

                      $("#PrintInvoice").val("");
                    }, 1000);
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(
                      err._body.replace(/"/g, ""),
                      "error"
                    );
                  }
                );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured  !", "Error");
            }
          );
      }
    } else {
      this.InvoiceType = "PrintLorryReceipt4";
      this.From = "Origin";
      this.ConsignmentNoteId = this.OrderId;
      this.CompId = this.CompanyId;
      $("#PrintInvoice").val("");
      this.PrintInvoice();
    }
  }

GetCourierLabel() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "oc_GetCourierMultiplebarcodeDataById", this.OrderId, null).subscribe((response) => {
      this.barcodedata = response;
      console.log("bd:", this.barcodedata);
      this.PrintBarcode();
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Barcode data !", "error");
        Helpers.setLoading(false);
      });
  }

PrintBarcode() {
  setTimeout(() => {
      var divElements = document.getElementById("print_label");
      if(!divElements){
        Helpers.setLoading(false);
      }
      var $iframe = $("<iframe id='frame'>").appendTo("body");
      var printDiv = "<style type='text/css' media='print'>@page { size: auto;  margin: 0mm; } @media print {@page {size: 4in 2in;}} .bordered-table {border-collapse: collapse;width: 100%;table-layout:auto} .bordered-table th, .bordered-table td {border: 2px solid black;}</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>"
      $iframe.contents().find("body").html(printDiv);
      console.log('print_label', divElements.innerHTML);
      const iframe = $iframe[0] as HTMLIFrameElement;
      const win = iframe.contentWindow;
      $(win.document).ready(function () {
        Helpers.setLoading(false);
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
    }, 500);
  }

  //end burhan - 29/12/25

  SubmissionData: any = [];
  PrintSubmission() {
    Helpers.setLoading(true);
    this._appService
      .GetById("Sales", "GetInvoiceSubmissionById", this.SubmissionId)
      .subscribe(
        (response) => {
          this.SubmissionData.push(response.Table[0]);
          this.SubmissionData[0].InvoiceList = [];
          this.SubmissionData[0].InvoiceList = response.Table1;
          this.GetByCustomerId(this.SubmissionData[0].CustomerId);
          this.SubmissionData[0].TotalInvoiceAmount = 0;
          this.SubmissionData[0].TotalDueAmount = 0;

          if (this.SubmissionData[0].InvoiceList.length > 0) {
            this.SubmissionData[0].InvoiceList.forEach(element => {
              this.SubmissionData[0].TotalInvoiceAmount += parseFloat(element.TotalAmount);
              this.SubmissionData[0].TotalDueAmount += parseFloat(element.AmountDue);
            });
          }

          setTimeout(() => {
            var divElements = document.getElementById("PrintSubmission");
            this.divElements = divElements.innerHTML;

            if (!this.OnlyHtmlView) {
              var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

              var printDiv = divElements.innerHTML;

              var win = $iframe[0].contentWindow || $iframe[0];

              $(win.document).ready(function () {
                setTimeout(() => {
                  win.window.print();

                  setTimeout(() => {
                    $iframe.remove();
                  }, 500);
                });
              });

              $iframe.contents().find("body").html(printDiv);

              $("#PrintInvoice").val("");
            }

            Helpers.setLoading(false);
          }, 1000);
          Helpers.setLoading(false);

        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occurred while fetching data!", "Error");
        }
      );
  }

  GetByCustomerId(Id: any) {
    this._appService.GetById("Sales", "GetCustomerById", Id).subscribe(
      (response) => {
        this.SubmissionData[0].Address = response[0].Address;
        this.SubmissionData[0].State = response[0].State;
        this.SubmissionData[0].City = response[0].City;
        this.SubmissionData[0].PostalCode = response[0].PostalCode;
        this.SubmissionData[0].Phone = response[0].Phone;
        this.SubmissionData[0].Email = response[0].Email;
        this.SubmissionData[0].IsTaxable = response[0].IsTaxable;
        this.SubmissionData[0].GST = response[0].GST;

        var GSTType = "";
        if (
          this.SelectedCompantGSTIN == response[0].GSTCode ||
          response[0].TaxPreference == "TaxableInternational"
        ) {
          if (
            (response[0].TaxExemptionsReason == "SEZ Customer Taxable" &&
              response[0].IsTaxable == true &&
              this.SalesFlag == false) ||
            response[0].TaxPreference == "TaxableInternational"
          ) {
            GSTType = "Inter";
          } else {
            GSTType = "Intra";
          }
        } else {
          GSTType = "Inter";
        }
      },
      (err) => {
        this.toastr.error("An error occured while deleting data !", "error");
      }
    );
  }

  // PrintGeeteeLR() {
  //   Helpers.setLoading(true);

  //   this._appService
  //     .GetByThreeId("BookingOrigin", "GetGeeteeLRPrintData", this.OrderId,this.BookingId,this.ConsignmentNoteId)
  //     .subscribe(
  //       (response) => {
  //         this.geeteePrintData = [];

  //         if (response.Table.length !==0) {
  //           this.geeteePrintData = response.Table;
  //           console.log('this.geeteePrintData',this.geeteePrintData);

  //            for (const item of this.geeteePrintData) {
  //             item.ProductDetails = [];
  //             if (item.ProductList != null) {
  //                item.ProductDetails = JSON.parse(item.ProductList);
  //             }

  //             item.FreightChargeDetails = [];
  //             if (item.FreightChargesList != null) {
  //                item.FreightChargeDetails = JSON.parse(item.FreightChargesList);
  //             }
  //           }

  //           for (const item of this.geeteePrintData) {
  //               item.totalGrossWeight  = 0;
  //               item.totalChargeableWeight  = 0;

  //               for (const itemPrd of item.ProductDetails) {
  //                   item.totalGrossWeight += Number(itemPrd.weight) || 0;
  //                   // item.totalChargeableWeight   += Number(itemPrd.Discount) || 0;
  //               }

  //               item.totalGrossWeight = item.totalGrossWeight.toFixed(2);
  //           }

  //         }

  //         // setTimeout(() => {
  //         // const divElements = document.getElementById("Print_Geetee_LR");

  //         // if (divElements) {
  //         //   const $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //         //   const printDiv = divElements.innerHTML;
  //         //   const win = $iframe[0].contentWindow || $iframe[0];
  //         //   console.log(divElements.innerHTML);
  //         //   $(win.document).ready(() => {
  //         //     setTimeout(() => {
  //         //       win.window.print();
  //         //       setTimeout(() => {
  //         //         $iframe.remove();
  //         //       }, 1000);
  //         //     });
  //         //   });

  //         //   $iframe.contents().find("body").html(printDiv);
  //         // }

  //         //   $("#PrintInvoice").val("");
  //         //   Helpers.setLoading(false);
  //         // }, 2000);


  //         setTimeout(() => {
  //             var divElements = document.getElementById("Print_Geetee_LR");
  //             var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
  //             var printDiv =
  //                 "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
  //                 divElements.innerHTML +
  //                 "</body></html>";
  //             var win = $iframe[0].contentWindow || $iframe[0];
  //             console.log(divElements.innerHTML);
  //             $(win.document).ready(function () {
  //                 setTimeout(() => {
  //                     win.window.print();
  //                     setTimeout(() => {
  //                         $iframe.remove();
  //                     }, 1000);
  //                 });
  //             });
  //             $iframe.contents().find("body").html(printDiv);
  //             $("#PrintInvoice").val("");
  //             Helpers.setLoading(false);
  //         }, 1000);


  //       },
  //       (err) => {
  //         Helpers.setLoading(false);
  //         this.toastr.error("An error occurred while fetching consignment data!", "Error");
  //       }
  //     );
  // }

  PrintGeeteeLR() {
    Helpers.setLoading(true);

    this._appService
      .GetByThreeId("BookingOrigin", "GetGeeteeLRPrintData", this.OrderId, this.BookingId, this.ConsignmentNoteId)
      .subscribe(
        (response) => {
          this.geeteePrintData = [];

          if (response) {
            this.geeteePrintData = response;
            console.log('this.geeteePrintData', this.geeteePrintData);

            for (const item of this.geeteePrintData) {
              item.ProductDetails = [];
              if (item.ProductList != null) {
                item.ProductDetails = JSON.parse(item.ProductList);
              }

              item.FreightChargeDetails = [];
              if (item.FreightChargesList != null) {
                item.FreightChargeDetails = JSON.parse(item.FreightChargesList);
              }
            }

            for (const item of this.geeteePrintData) {
              item.totalGrossWeight = 0;
              item.totalChargeableWeight = 0;
              item.totalFreightCharge = 0;

              for (const itemPrd of item.ProductDetails) {
                item.totalGrossWeight += Number(itemPrd.weight) || 0;
                item.totalChargeableWeight += Number(itemPrd.ChargeableWeight) || 0;
              }

              for (const itemPrd of item.FreightChargeDetails) {
                item.totalFreightCharge += Number(itemPrd.Amount) || 0;
                // item.totalChargeableWeight   += Number(itemPrd.Discount) || 0;
              }

              item.totalChargeableWeight = item.totalChargeableWeight.toFixed(2);
            }
          }

          let i = 0;

          this._appService
            .GetByTwoId("Booking", "GetDataForLRPrint", this.BookingId, this.CompanyId)
            .subscribe(
              (res) => {
                Helpers.setLoading(false);

                if (res && res.length > 0 && this.geeteePrintData.length > 0) {
                  const data = res[0];
                  const consignment = this.geeteePrintData[0];

                  consignment.DriverName = data.DriverName;
                  consignment.VehicleType = data.VehicleType;
                  consignment.transporterAddress = data.transporterAddress;
                  consignment.LicenseNo = data.LicenseNo;
                  consignment.TransportName = data.TransportName;
                  consignment.eWayBillNo = data.eWayBillNo;
                  consignment.eWayBillExpiryDate = data.eWayBillExpiryDate;
                  consignment.containerNo = data.containerNo;
                  consignment.sealNo = data.sealNo;
                  consignment.DINo = data.DINo;
                  consignment.companyHeadAddress = data.companyHeadAddress;
                }

                setTimeout(() => {
                  this.geeteePrintData.forEach((element) => {
                    // const risk = (element.Risk || "").toLowerCase();
                    // const freight = (element.Freight || "").replace(/\s+/g, "").toLowerCase();
                    // const gst = (element.GST || "").toLowerCase();

                    // if (risk === "owner") {
                    //   $("#chkOwn_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkTransporter_" + i).prop("checked", true);
                    // }

                    // if (["topay"].includes(freight)) {
                    //   $("#chkToPay_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkToBill_" + i).prop("checked", true);
                    // }

                    // if (gst === "consignor") {
                    //   $("#chkConsignor_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkGSTTransporter_" + i).prop("checked", true);
                    // }

                    // if (element.Insured) {
                    //   $("#chkInsureYes_" + i).prop("checked", true);
                    // } else {
                    //   $("#chkInsureNo_" + i).prop("checked", true);
                    // }

                    let TotalQty = 0;
                    let TotalWeight = 0;
                    let TotalValue = 0;

                    (element.ProductDetail || []).forEach((p) => {
                      TotalQty += p.Quantity || 0;
                      TotalWeight += p.GrossWeight || 0;
                      TotalValue += p.Value || 0;
                    });

                    element.TotalQty = TotalQty;
                    element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                    element.TotalValue = TotalValue;

                    i++;
                  });

                  // if (this.geeteePrintData.length > 0) {
                  //   const cargoMode = (PrintFormatsComponent.that.geeteePrintData[0].CargoMode || "").toLowerCase();
                  //   this.CargoModesList.forEach(element => {
                  //     const label = element.Label || "";
                  //     const classSelector = `.chk_${label}`;

                  //     if (label.toLowerCase() === cargoMode) {
                  //       $(classSelector).attr("checked", "checked");
                  //     } else {
                  //       $(classSelector).removeAttr("checked");
                  //     }
                  //   });

                  //   const freight = (PrintFormatsComponent.that.geeteePrintData[0].Freight || "").replace(/\s+/g, "").toLowerCase();
                  //   if (freight === "topay") {
                  //     $(".chkPaymentModeToPay").attr("checked", "checked");
                  //   } else {
                  //     $(".chkPaymentModeToPay").removeAttr("checked");
                  //   }

                  //   if (freight === "tobill") {
                  //     $(".chkPaymentModeToBilled").attr("checked", "checked");
                  //     PrintFormatsComponent.that.geeteePrintData[0].Advance = 0;
                  //     PrintFormatsComponent.that.geeteePrintData[0].FreightCharges = 0;
                  //     PrintFormatsComponent.that.geeteePrintData[0].FOVCharges = 0;
                  //     PrintFormatsComponent.that.geeteePrintData[0].StationeryCharges = 0;
                  //     PrintFormatsComponent.that.geeteePrintData[0].CODCharges = 0;
                  //     PrintFormatsComponent.that.geeteePrintData[0].TotalCharges = 0;
                  //   } else {
                  //     $(".chkPaymentModeToBilled").removeAttr("checked");
                  //   }

                  //   const risk = (PrintFormatsComponent.that.geeteePrintData[0].Risk || "").toLowerCase();
                  //   if (risk === "owner") {
                  //     $(".chkOwnerRisk").attr("checked", "checked");
                  //   } else {
                  //     $(".chkOwnerRisk").removeAttr("checked");
                  //   }

                  //   if (risk === "transporter") {
                  //     $(".chkTransporterRisk").attr("checked", "checked");
                  //   } else {
                  //     $(".chkTransporterRisk").removeAttr("checked");
                  //   }
                  // }
                }, 1000);

                // Print Section
                setTimeout(() => {
                  this.cd.detectChanges();
                  const divElements = document.getElementById("Print_Geetee_LR");

                  if (divElements) {
                    const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                    const printDiv = divElements.innerHTML;
                    const win = $iframe[0].contentWindow || $iframe[0];
                    console.log(divElements.innerHTML);
                    $(win.document).ready(() => {
                      setTimeout(() => {
                        win.window.print();
                        setTimeout(() => {
                          $iframe.remove();
                        }, 500);
                      });
                    });

                    $iframe.contents().find("body").html(printDiv);
                  }

                  $("#PrintInvoice").val("");
                  Helpers.setLoading(false);
                }, 1000);
              },
              (err) => {
                Helpers.setLoading(false);
                this.toastr.error(err._body.replace(/"/g, "") || "Unknown error", "Error");
              }
            );
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occurred while fetching consignment data!", "Error");
        }
      );
  }

  @ViewChild('Detail1ForDigitalPrint') Detail1DivDigitalSign: ElementRef;
  PrintDetail1ForDigitalPrint() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail1ForDigitalPrint");
      this.divElements = divElements.innerHTML;

      console.log("isDigitalsignin", this.isDigitalsignin)
      if (!this.OnlyHtmlView) {

        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv =
          "<style type='text/css' media='print'>@page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        console.log("printDiv", printDiv);
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  @ViewChild('PDF_EInvoiceForDigitalSign') Detail2DivDigitalSign: ElementRef;
  Print_PDF_EInvoiceForDigitalSign() {
    setTimeout(() => {
      var divElements = document.getElementById("Print_PDF_EInvoiceForDigitalSign");
      this.divElements = divElements.innerHTML;

      console.log("isDigitalsignin", this.isDigitalsignin)
      if (!this.OnlyHtmlView) {

        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv =
          "<style type='text/css' media='print'>@page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
          divElements.innerHTML +
          "</body></html>";
        // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        console.log("printDiv", printDiv);
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintInvoice").val("");
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  // TotalAmount: any = 0;
  // TotalAdvance: any = 0;
  // TotalBalance: any = 0;
  @ViewChild('New_PrintQuote') New_PrintQuoteDiv: ElementRef;
  NewPrintQuote() {
     Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle","GetOrderVehicleById",this.OrderId,this.CompanyId).subscribe(
    (response) => {
      PrintFormatsComponent.that.PrintQuoteData = [];
      if(response){
        // this.PrintQuoteData = response;
        PrintFormatsComponent.that.PrintQuoteData.push(response);
        //PrintFormatsComponent.that.PrintQuoteData = response ? [response] : [];
        console.log('PrintQuoteData>>',this.PrintQuoteData);
      }
      console.log('PrintQuoteData',this.PrintQuoteData);
      this.TotalAmount = 0;
      this.TotalAdvance = 0;
      this.TotalBalance = 0;

      let i = 0;
      this.InvoiceData = [];
      this.QuoteCompanyData = {};
      this.QuoteUserData = {};

      this._appService.GetById("byVehicleIncome","GetChargeListByIndentId",this.OrderId)
        .subscribe(
          (res) => {
            res.forEach((element) => {
              this.InvoiceData.push(element);
              this.TotalAmount = this.TotalAmount + element.Amount;
              this.TotalAdvance = this.TotalAdvance + element.Advance;
              this.TotalBalance = this.TotalAmount - this.TotalAdvance;
            });

            this._appService
              .GetById("OrdersByVehicle", "GetCompanyForQuote", this.UserId)
              .subscribe(
                (res) => {
                  // this.QuoteCompanyData = res.Table[0];
                  // this.QuoteUserData = res.Table1[0];
                  this.QuoteCompanyData = res.Table && res.Table.length ? res.Table[0] : {};
                  this.QuoteUserData = res.Table1 && res.Table1.length ? res.Table1[0] : {};

                  this.quoteCompanyEmail = this.QuoteCompanyData.Email || '';
                  this.companyName = this.QuoteCompanyData.Company || '';

                  this.quoteUserName = this.QuoteUserData.UserName || '';
                  this.quoteUserEmail = this.QuoteUserData.Email || '';
                  this.quoteUserPhone = this.QuoteUserData.PhoneNumber || '';


                  setTimeout(() => {
                  this.cd.detectChanges();
                  const divElements = document.getElementById("New_PrintQuote");
                  this.divElements = divElements.innerHTML;
                  if (!this.OnlyHtmlView) {
                    if (divElements) {
                      const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                      const printDiv = divElements.innerHTML;
                      const win = $iframe[0].contentWindow || $iframe[0];
                      console.log(divElements.innerHTML);
                      $(win.document).ready(() => {
                        setTimeout(() => {
                          win.window.print();
                          setTimeout(() => {
                            $iframe.remove();
                          }, 500);
                        });
                      });

                      $iframe.contents().find("body").html(printDiv);
                    }

                    $("#PrintInvoice").val("");
                    Helpers.setLoading(false);
                  }
                  }, 5000);

                  // setTimeout(() => {
                  //   // kevin 13/03/2020
                  //   this.cd.detectChanges();
                  //   var divElements = document.getElementById("New_PrintQuote");
                  //   // var $iframe = $("<iframe id='frame'>").appendTo("body");
                  //   var printDiv =
                  //     "<html><head><title> Lorry Receipt </title></head><body>" +
                  //     divElements.innerHTML +
                  //     "</body></html>";

                  //   var $iframe: any = $("<iframe id='frame'>").appendTo("body");
                  //   var printDiv = divElements.innerHTML;
                  //   console.log(divElements.innerHTML);
                  //   var win = $iframe[0].contentWindow || $iframe[0];
                  //   $(win.document).ready(function () {
                  //     setTimeout(() => {
                  //       win.window.print();
                  //       setTimeout(() => {
                  //         $iframe.remove();
                  //       }, 500);
                  //     });
                  //   });
                  //   $iframe.contents().find("body").html(printDiv);
                  //   $("#PrintInvoice").val("");
                  //   Helpers.setLoading(false);
                  // }, 1000);
                  Helpers.setLoading(false);
                },
                (err) => {
                   Helpers.setLoading(false);
                  this.toastr.error("An error occured  !", "Error");
                }
              );
          },
          (err) => {
             Helpers.setLoading(false);
            this.toastr.error("An error occured  !", "Error");
          }
        );
    },
    (error)=>{
      Helpers.setLoading(false);
      this.toastr.error('Error while fetching print qoute data');
    }
    );
  }

  // Added by priya - 30/12/2025 - print payment advice for payment made 
  PrintPaymentAdvice() {
    console.log('print', this.PrintData, this.PaymentData)
    this.SubTotalBillAmount = 0;
    this.SubTotalPaidAmount = 0;
    this.SubTotalAmountDue = 0;
    this.SubTotalPaymentAmount = 0;
    this.SubTotalTDS = 0;
    for (let index = 0; index < this.PrintData[0].PrintPaymentDetails.length; index++) {
      this.SubTotalBillAmount =
        this.PrintData[0].PrintPaymentDetails[index].BillAmount +
        this.SubTotalBillAmount;
      this.SubTotalPaidAmount =
        this.PrintData[0].PrintPaymentDetails[index].PaidAmount +
        this.SubTotalPaidAmount;
      this.SubTotalAmountDue =
        this.PrintData[0].PrintPaymentDetails[index].AmountDue + this.SubTotalAmountDue;
      this.SubTotalPaymentAmount =
        this.PrintData[0].PrintPaymentDetails[index].Payment +
        this.SubTotalPaymentAmount;
      this.SubTotalTDS =
        this.PrintData[0].PrintPaymentDetails[index].TDS +
        this.SubTotalTDS;
    }

    this.SubTotalBillAmount = parseFloat(
      this.SubTotalBillAmount.toFixed(2)
    );
    this.SubTotalPaidAmount = parseFloat(
      this.SubTotalPaidAmount.toFixed(2)
    );
    this.SubTotalAmountDue = parseFloat(this.SubTotalAmountDue.toFixed(2));
    this.SubTotalPaymentAmount = parseFloat(
      this.SubTotalPaymentAmount.toFixed(2)
    );
    this.http.get(environment.apiUrl +
      "api/Company/GetUserCompanyDataByInvoice?id=" +
      this.CompId +
      "&param1=" +
      'CompanyId').subscribe(
        (response: any) => {
          let data: any = response.data; //FOR DROPDOWN
          data.forEach((element) => {
            this.CompanyIdForCookie = element;

            this.CompanyId = this.CompanyIdForCookie.Id;
            this.SelectedComapnyName =
              this.CompanyIdForCookie.SelectedComapnyName;
            this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
            this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
            this.SelectedCompantGSTIN =
              this.CompanyIdForCookie.SelectedCompantGSTIN;
            this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
            this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
            this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
            this.SelectedCompantEmail =
              this.CompanyIdForCookie.SelectedComapnyEmail;
            this.SelectedCompanyPhone =
              this.CompanyIdForCookie.SelectedCompanyPhone;
            this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
            this.SelectedCompanyOther =
              this.CompanyIdForCookie.SelectedCompanyMSME;
            //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
            this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
            this.SelectedCompanyLogoImg =
              environment.apiUrl + this.SelectedCompanyLogo;
            //added by vithujan 22-06-2023
            this.SelectedCompanyMSME =
              this.CompanyIdForCookie.SelectedCompanyMSME;
            this.SelectedCompanyMSMENum = this.CompanyIdForCookie.SelectedCompanyMSMENum;
            this.SelectedBranchName = this.CompanyIdForCookie.Label;
            this.SelectedCompanyHeadAddress = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
            this.SelectedCompanyHeadPhone = this.CompanyIdForCookie.SelectedCompanyHeadPhone;
            this.CompanyBranchNames = this.CompanyIdForCookie.BranchNames;
            this.SelectedCompanySAC = this.CompanyIdForCookie.SelectedCompanySAC;
          });
        })
    
    this.cd.detectChanges();
    setTimeout(() => {
      console.log('print paymentdata', this.PrintData)
      var divElements = document.getElementById("PrintPaymentAdviceX1");
      this.divElements = divElements.innerHTML;
      if (divElements) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        console.log('printDiv', printDiv)
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
              Helpers.setLoading(false);
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintPaymentAdviceX1").val("");
      }
      else {
        Helpers.setLoading(false);
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintDetailPaymentAdvice() {
    console.log('print', this.PrintData, this.PaymentData)
    this.http.get(environment.apiUrl +
      "api/Company/GetUserCompanyDataByInvoice?id=" +
      this.CompId +
      "&param1=" +
      'CompanyId').subscribe(
      (response: any) => {
        let data: any = response.data; //FOR DROPDOWN
        data.forEach((element) => {
          this.CompanyIdForCookie = element;
          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName =
            this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN =
            this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
          this.SelectedCompantEmail =
            this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyPhone =
            this.CompanyIdForCookie.SelectedCompanyPhone;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.SelectedCompanyOther =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg =
            environment.apiUrl + this.SelectedCompanyLogo;
          //added by vithujan 22-06-2023
          this.SelectedCompanyMSME =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          this.SelectedCompanyMSMENum = this.CompanyIdForCookie.SelectedCompanyMSMENum;
          this.SelectedBranchName = this.CompanyIdForCookie.Label;
          this.SelectedCompanyHeadAddress = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
          this.SelectedCompanyHeadPhone = this.CompanyIdForCookie.SelectedCompanyHeadPhone;
          this.CompanyBranchNames = this.CompanyIdForCookie.BranchNames;
          this.SelectedCompanySAC = this.CompanyIdForCookie.SelectedCompanySAC;
        });
      })

    setTimeout(() => {
      console.log('print paymentdata', this.PrintData)
      var divElements = document.getElementById("PrintDetailPaymentAdviceX2");
      this.divElements = divElements.innerHTML;
      if (divElements) {
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv = divElements.innerHTML;
        console.log('printDiv', printDiv)
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
          setTimeout(() => {
            win.window.print();
            setTimeout(() => {
              $iframe.remove();
              Helpers.setLoading(false);
            }, 500);
          });
        });
        $iframe.contents().find("body").html(printDiv);
        $("#PrintDetailPaymentAdviceX2").val("");
      }
      else{
        Helpers.setLoading(false);
      }
      Helpers.setLoading(false);
    }, 1000);
  }

  // getUserCompanyData(): Observable<any> {
  //   return this.http.get<any>(
  //     environment.apiUrl +
  //     "api/Company/GetUserCompanyDataByInvoice?id=" +
  //     this.CompId +
  //     "&param1=CompanyId"
  //   );
  // }

  // PrintPaymentAdvice() {
  //   console.log('print', this.PrintData, this.PaymentData);
  //   this.SubTotalBillAmount = 0;
  //   this.SubTotalPaidAmount = 0;
  //   this.SubTotalAmountDue = 0;
  //   this.SubTotalPaymentAmount = 0;
  //   this.SubTotalTDS = 0;

  //   for (let i = 0; i < this.PrintData[0].PrintPaymentDetails.length; i++) {
  //     this.SubTotalBillAmount += this.PrintData[0].PrintPaymentDetails[i].BillAmount;
  //     this.SubTotalPaidAmount += this.PrintData[0].PrintPaymentDetails[i].PaidAmount;
  //     this.SubTotalAmountDue += this.PrintData[0].PrintPaymentDetails[i].AmountDue;
  //     this.SubTotalPaymentAmount += this.PrintData[0].PrintPaymentDetails[i].Payment;
  //     this.SubTotalTDS += this.PrintData[0].PrintPaymentDetails[i].TDS;
  //   }

  //   this.SubTotalBillAmount = +this.SubTotalBillAmount.toFixed(2);
  //   this.SubTotalPaidAmount = +this.SubTotalPaidAmount.toFixed(2);
  //   this.SubTotalAmountDue = +this.SubTotalAmountDue.toFixed(2);
  //   this.SubTotalPaymentAmount = +this.SubTotalPaymentAmount.toFixed(2);

  //   Observable.forkJoin([
  //     this.getUserCompanyData()
  //   ]).subscribe(([company]) => {
  //     company.data.forEach((element) => {
  //       this.CompanyIdForCookie = element;
  //       this.CompanyId = this.CompanyIdForCookie.Id;
  //       this.SelectedComapnyName = this.CompanyIdForCookie.SelectedComapnyName;
  //       this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
  //       this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
  //       this.SelectedCompantGSTIN = this.CompanyIdForCookie.SelectedCompantGSTIN;
  //       this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
  //       this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
  //       this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
  //       this.SelectedCompantEmail = this.CompanyIdForCookie.SelectedComapnyEmail;
  //       this.SelectedCompanyPhone = this.CompanyIdForCookie.SelectedCompanyPhone;
  //       this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
  //       this.SelectedCompanyOther = this.CompanyIdForCookie.SelectedCompanyMSME;
  //       this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
  //       this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
  //       this.SelectedCompanyMSME = this.CompanyIdForCookie.SelectedCompanyMSME;
  //       this.SelectedCompanyMSMENum = this.CompanyIdForCookie.SelectedCompanyMSMENum;
  //       this.SelectedBranchName = this.CompanyIdForCookie.Label;
  //       this.SelectedCompanyHeadAddress = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
  //       this.SelectedCompanyHeadPhone = this.CompanyIdForCookie.SelectedCompanyHeadPhone;
  //       this.CompanyBranchNames = this.CompanyIdForCookie.BranchNames;
  //       this.SelectedCompanySAC = this.CompanyIdForCookie.SelectedCompanySAC;
  //     });
  //     setTimeout(() => {
  //       console.log('print paymentdata', this.PrintData)
  //       var divElements = document.getElementById("PrintPaymentAdviceX1");
  //       this.divElements = divElements.innerHTML;
  //       if (divElements) {
  //         var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
  //         var printDiv = divElements.innerHTML;
  //         console.log('printDiv', printDiv)
  //         var win = $iframe[0].contentWindow || $iframe[0];
  //         $(win.document).ready(function () {
  //           setTimeout(() => {
  //             win.window.print();
  //             setTimeout(() => {
  //               $iframe.remove();
  //             }, 500);
  //           });
  //         });
  //         $iframe.contents().find("body").html(printDiv);
  //         $("#PrintPaymentAdviceX1").val("");
  //       }
  //       Helpers.setLoading(false);
  //     }, 1000);
  //   });
  // }

  // PrintDetailPaymentAdvice() {
  //   Observable.forkJoin([
  //     this.getUserCompanyData()
  //   ]).subscribe(([company]) => {
  //     company.data.forEach((element) => {
  //       this.CompanyIdForCookie = element;
  //       this.CompanyId = this.CompanyIdForCookie.Id;
  //       this.SelectedComapnyName = this.CompanyIdForCookie.SelectedComapnyName;
  //       this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
  //       this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
  //       this.SelectedCompantGSTIN = this.CompanyIdForCookie.SelectedCompantGSTIN;
  //       this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
  //       this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
  //       this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
  //       this.SelectedCompantEmail = this.CompanyIdForCookie.SelectedComapnyEmail;
  //       this.SelectedCompanyPhone = this.CompanyIdForCookie.SelectedCompanyPhone;
  //       this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
  //       this.SelectedCompanyOther = this.CompanyIdForCookie.SelectedCompanyMSME;
  //       this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
  //       this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
  //       this.SelectedCompanyMSME = this.CompanyIdForCookie.SelectedCompanyMSME;
  //       this.SelectedCompanyMSMENum = this.CompanyIdForCookie.SelectedCompanyMSMENum;
  //       this.SelectedBranchName = this.CompanyIdForCookie.Label;
  //       this.SelectedCompanyHeadAddress = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
  //       this.SelectedCompanyHeadPhone = this.CompanyIdForCookie.SelectedCompanyHeadPhone;
  //       this.CompanyBranchNames = this.CompanyIdForCookie.BranchNames;
  //       this.SelectedCompanySAC = this.CompanyIdForCookie.SelectedCompanySAC;
  //     });
  //     setTimeout(() => {
  //       console.log('print paymentdata', this.PrintData)
  //       var divElements = document.getElementById("PrintDetailPaymentAdviceX2");
  //       this.divElements = divElements.innerHTML;
  //       if (divElements) {
  //         var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
  //         var printDiv = divElements.innerHTML;
  //         console.log('printDiv', printDiv)
  //         var win = $iframe[0].contentWindow || $iframe[0];
  //         $(win.document).ready(function () {
  //           setTimeout(() => {
  //             win.window.print();
  //             setTimeout(() => {
  //               $iframe.remove();
  //             }, 500);
  //           });
  //         });
  //         $iframe.contents().find("body").html(printDiv);
  //         $("#PrintDetailPaymentAdviceX2").val("");
  //       }
  //       Helpers.setLoading(false);
  //     }, 1000);
  //   });
  // }

  // added by BURHAN - 20-Feb-2026
  // IsPrintLr5: boolean = false;
  // printContent(elementId: string, title: string = "Lorry Receipt") {
  //   // this.cd.detectChanges();
  //   this.IsPrintLr5 = elementId == 'ModalConsignmentNote_LR5' ? true : false;
  //   setTimeout(() => {
  //   //   this.cd.detectChanges();
  //     const div = document.getElementById(elementId);
  //     if (!div) return;

  //     const isLR5 = elementId === "ModalConsignmentNote_LR5";
  //     const isMobile =
  //       /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //         navigator.userAgent || navigator.vendor || (window as any).opera || ''
  //       ) ||
  //       window.innerWidth < 420 ||
  //       screen.width < 420;
  //     const content = div.innerHTML;
      
  //     const iframe = document.createElement("iframe");
  //     iframe.style.position = "absolute";
  //     iframe.style.width = "0px";
  //     iframe.style.height = "0px";
  //     iframe.style.border = "none";
  //     document.body.appendChild(iframe);
      
  //     if (!isMobile) {
  
  //       console.log(`Printing ${elementId} - Is Mobile:`, isMobile);
  
  //       const pageStyle = isLR5 ? '<style>@page { size: landscape; }</style>' : '';

  //       const doc = iframe.contentWindow.document;
  //       doc.open();
  //       doc.write(`
  //           <html>
  //             <head>
  //             <title>${title}</title>
  //             ${pageStyle}
  //             </head>
  //             <body>${div.innerHTML}</body>
  //           </html>
  //         `);
  //       doc.close();
  //       iframe.contentWindow.focus();
  //       iframe.contentWindow.print();
  //     } else {
  //       const printWin = window.open("", "_blank");

  //       if (!printWin) {
  //         alert("Popup blocked! Please allow popups for printing on mobile.");
  //         Helpers.setLoading(false);
  //         return;
  //       }

  //       const landscapeStyle = isLR5 ? '@media print { @page { size: landscape; } }' : '';

  //       printWin.document.open();
  //       printWin.document.write(`
  //         <!DOCTYPE html>
  //         <html>
  //           <head>
  //             <title>${title}</title>
  //             <meta charset="UTF-8">
  //             <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //             <style>${landscapeStyle}</style>
  //           </head>
  //           <body>
  //             ${content}
  //           </body>
  //         </html>
  //       `);
  //       printWin.document.close();

  //       printWin.focus();
  //       printWin.print();
  //       printWin.close();
  //     }
  //     setTimeout(() => {
  //       document.body.removeChild(iframe);

  //     }, 300);
  //   }, 0)

  //   // const div = document.getElementById(elementId);
  //   // if (!div) {
  //   //   console.error(`${elementId} not found`);
  //   //   Helpers.setLoading(false);
  //   //   return;
  //   // }

  //   // const content = div.innerHTML;
  //   // const isMobile =
  //   //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //   //     navigator.userAgent || navigator.vendor || (window as any).opera || ''
  //   //   ) ||
  //   //   window.innerWidth < 420 ||
  //   //   screen.width < 420;

  //   // console.log(`Printing ${elementId} - Is Mobile:`, isMobile);

  //   // const isLR5 = elementId === "ModalConsignmentNote_LR5";
  //   // const pageStyle = isLR5 ? '<style>@page { size: landscape; }</style>' : '';

    
  //   // if (!isMobile) {
  //   //   // DESKTOP - FIXED VERSION
  //   //   const $iframe = $("<iframe id='frame'>").appendTo("body");

  //   //   $iframe.contents().find("body").html(`
  //   //     <html>
  //   //       <head>
  //   //         <title>${title}</title>
  //   //         ${pageStyle}
  //   //       </head>
  //   //       <body>${content}</body>
  //   //     </html>
  //   //   `);

  //   //   // Wait a bit longer for iframe to be ready
  //   //   setTimeout(() => {
  //   //     const iframeEl = $iframe[0] as HTMLIFrameElement;
  //   //     const win = iframeEl.contentWindow;

  //   //     if (!win) {
  //   //       console.error("iframe contentWindow is null");
  //   //       $iframe.remove();
  //   //       Helpers.setLoading(false);
  //   //       return;
  //   //     }

  //   //     try {
  //   //       win.focus();           // Helps on some browsers
  //   //       win.print();
  //   //     } catch (e) {
  //   //       console.error("Desktop print failed:", e);
  //   //     }

  //   //     setTimeout(() => {
  //   //       $iframe.remove();
  //   //       Helpers.setLoading(false);
  //   //     }, 800);

  //   //   }, 1000); // Increased delay to ensure contentWindow is available

  //   // } else {
  //   //   // MOBILE - unchanged (your working version)
  //   //   const printWin = window.open("", "_blank");

  //   //   if (!printWin) {
  //   //     alert("Popup blocked! Please allow popups for printing on mobile.");
  //   //     Helpers.setLoading(false);
  //   //     return;
  //   //   }

  //   //   const landscapeStyle = isLR5 ? '@media print { @page { size: landscape; } }' : '';

  //   //   printWin.document.write(`
  //   //   <!DOCTYPE html>
  //   //   <html>
  //   //   <head>
  //   //     <title>${title}</title>
  //   //     <meta charset="UTF-8">
  //   //     <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //   //     <style>${landscapeStyle}</style>
  //   //   </head>
  //   //   <body>
  //   //     ${content}
  //   //   </body>
  //   //   </html>
  //   // `);

  //   //   printWin.document.close();

  //   //   setTimeout(() => {
  //   //     try {
  //   //       printWin.focus();
  //   //       printWin.print();
  //   //     } catch (e) {
  //   //       console.error(`Mobile print failed for ${elementId}:`, e);
  //   //     }
  //   //     Helpers.setLoading(false);
  //   //   }, 1800);
  //   // }
  // }
    // End by BURHAN - 20-Feb-2026
  //added by burhan - 20-Feb-2026
  //added by BURHAN - 6-March-2026(mobile-screen landscape print for Aplha LR)
  IsPrintLr5: boolean = false;

  async printContent(elementId: string, title: string = "Lorry Receipt") {
    //this.GetTermsAndConditions(); //added by BURHAN - 10-July-2026
    await this.GetTermsAndConditions();
    this.IsPrintLr5 = elementId === 'ModalConsignmentNote_LR5';

    setTimeout(() => {
      const div = document.getElementById(elementId);
      if (!div) {
        console.error(`${elementId} not found`);
        Helpers.setLoading(false);
        return;
      }

      let content = div.outerHTML;  // outerHTML better hai (full element with styles)

      // added by BURHAN - 8-July-2026 - T&C for LR4
      if (elementId === 'PrintLorryReceipt4' || elementId === 'ModalConsignmentNote_LR5' && this.TermsandConditionsLR && this.TermsandConditionsLR.trim() !== '') {
        const termsDiv = `
          <div style="page-break-before: always">
            <table style="width: 100%; border-collapse: collapse; font-family: calibri;">
              <tr>
                <td style="border: 1px solid; padding: 10px;">
                  <h2><i><u>LR TERMS & CONDITION :</u></i></h2>
                  <span style="font-size: 14px">${this.TermsandConditionsLR}</span>
                </td>
              </tr>
            </table>
          </div>
        `;
        content = content + termsDiv;
      }
      // end by BURHAN - 8-July-2026

      const isLR5 = elementId === "ModalConsignmentNote_LR5";
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent || navigator.vendor || (window as any).opera || ''
        ) ||
        window.innerWidth < 420 ||
        screen.width < 420;

      console.log(`Printing ${elementId} - Is Mobile: ${isMobile}, Is LR5: ${isLR5}`);

      if (!isMobile) {
        // DESKTOP 
        const pageStyle = isLR5 ? '<style>@page { size: landscape; margin: 5mm; }</style>' : '';

        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        if (doc) {
          doc.open();
          doc.write(`
          <html>
            <head>
              <title>${title}</title>
              ${pageStyle}
            </head>
            <body>${content}</body>
          </html>
        `);
          doc.close();

          setTimeout(() => {
            try {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
            } catch (e) {
              console.error("Desktop print error:", e);
            }
            setTimeout(() => {
              document.body.removeChild(iframe);
              Helpers.setLoading(false);
            }, 800);
          }, 1000); // 1 sec delay for render
        }
      } else {
        // MOBILE – improved with proper delay + focus
        const printWin = window.open("", "_blank");

        if (!printWin) {
          alert("Popup blocked! Please allow popups for printing on mobile.");
          Helpers.setLoading(false);
          return;
        }

        let landscapeStyle = '';
        if (isLR5) {
          landscapeStyle = `
          <style>
            @page {
              size: A4 landscape;
              margin: 5mm;
            }
            body, html {
              margin: 0;
              padding: 0;
              width: 100%;
              height: auto;
            }
            #${elementId} {
              width: 100%;
              max-width: 1123px;  /* A4 landscape px approx */
              min-height: 794px;
              box-sizing: border-box;
            }
            @media print {
              body, html {
                width: 297mm !important;
                height: 210mm !important;
                margin: 0 !important;
              }
              #${elementId} {
                width: 297mm !important;
                height: 210mm !important;
              }
            }
          </style>
        `;
        }

        printWin.document.open();
        printWin.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${title}</title>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            ${landscapeStyle}
          </head>
          <body>
            ${content}
          </body>
        </html>
      `);
        printWin.document.close();

        // Delay + focus – mobile pe print dialog khulwane ke liye zaroori
        setTimeout(() => {
          try {
            printWin.focus();
            printWin.print();
          } catch (e) {
            console.error(`Mobile print failed for ${elementId}:`, e);
            alert("Print failed on mobile. Try refreshing or use desktop.");
          }
          Helpers.setLoading(false);

          // Auto close after 8 sec (user print cancel na kare toh)
          setTimeout(() => {
            if (printWin && !printWin.closed) {
              printWin.close();
            }
          }, 8000);
        }, 1200); // 1.2 sec – content load hone ke liye kaafi
      }
    }, 0);
  }
  //ended by BURHAN - 6-March-2026
  //For Table Headers Font Color
  GetSaveTablesHeaderInRed() {
    this._appService.GetById("Common", "GetSystemSettingByName", "TableHeadersInRedColor").subscribe(
      (response) => {
        if (response == "1") {
          this.SaveTablesHeaderColorFlag = true;
        } else {
          this.SaveTablesHeaderColorFlag = false;
        }
        console.log("Tables Header Need Color:", this.SaveTablesHeaderColorFlag);
      },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      }
    );
  }

  //added by BURHAN - 10-July-2026
  GetTermsAndConditions(): Promise<void> {
    return new Promise((resolve) => {
      this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
        (response) => {
          this.TermsandConditionsLR = response || '';
          resolve();
        },
        (error) => {
          console.log("GetTermsAndConditions", error);
          this.TermsandConditionsLR = '';
          resolve(); // error pe bhi resolve karna zaroori hai warna print hang ho jayega
        }
      );
    });
  }
  //end by BURHAN -10-July-2026
  IsInvoiceLetterHeadSealContainer: boolean = false;
  GetInvoiceLetterHeadSealContainer() {
    this._appService.GetById("Common", "GetSystemSettingByName", "IsInvoiceLetterHeadSealContainer").subscribe(
      (response) => {
        if (response == "1") {
          this.IsInvoiceLetterHeadSealContainer = true;
        } else {
          this.IsInvoiceLetterHeadSealContainer = false;
        }
        console.log("Tables Header Need Color:", this.SaveTablesHeaderColorFlag);
      },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      }
    );
  }
}
